// MovementCore.jsx

import React, { useEffect, useState, useRef, useMemo, useCallback, useContext } from 'react';
import {getMeasuredExercises, getRealTimeDetection} from './Services/GetMeasurementRequestHandler';
import CONSTANT from "../../../constants/Constant";
import { getQueuedMovements, getAddedRemovedExercises, callStartOverApi} from "./Services/ExerciseService";
import { toast } from 'react-toastify';
import {playAudio, playAudioWithRetry, getAudioUrl, getMessageByKeyTexts, getMessageByKeyText, convertToBase64, forceStopAllAudio} from "../../../utils/Utils";
import { processExerciseVideo } from '../services/VideoSavingService';
import LeftSidePanel from './LeftSidePanel';
import RightSidePanel from './RightSidePanel';
import VideoPanel from './VideoPanel';
import HeaderPanel from './HeaderPanel';
import CountDown from './CountDown';
import NotificationAlert from './NotificationModal';
import StaticVideoModal from './StaticVideoModal';
import RetakeNotificationModal from './RetakeNotificationModal';
import ExamineticsProgressModal from './ExamineticsProgressModal';
import {
    getChunksToBlob,
    clearIntervalAndStopAudio,
    doesUserNeedFacingLeft,
    doesUserNeedFacingRight
} from './utilities/Utility';
import { getSweetAlertModalConfig } from '../../../services/dom/AlertService';
import {
    getLastPerformedMovement, getTotalCompletedPercentage, getTotalCompleted,
    getMovementsOfSelectedStatus, setMovementStatus, updateExerciseList, getNextMovement,
    analyzeMovementVideo, getPatientId, checkAllPainQuestionAnswered, setStatusOfSelectedExercise,
    getVideoLength, getChildrenValue, playPatientNotStandingFacingRight, playPatientNotStandingFacingLeft
} from './Services/MovementService';
import { skipMovement, updateUserData, saveSkipReasonQuestions} from './Services/AssessementService';
import GLOBAL from '../../../global';
import Progressbar from '../ProgressBar';
import VideoTopElement from './VideoTopElement';
import NetworkCheck from './NetworkCheck';
import VideoToolbar from './VideoToolbar';
import BiometricLoader from './BiometricLoader';
import StopWatch from './StopWatch';
import HeightForm from './HeightForm';
import Guideline from "../../../assets/img/movement/Guideline.svg";
import DownArrow from "../../../assets/img/utils/DownArrow.svg";
import AppContext from '../../../contexts/AppContext';
import { setPrimaryCamera } from './Services/cameraService';
import allowCameraImg from '../../../assets/img/movement/allowCamera.jpg';
// import { redirectTo } from '../chatbotNew/ChatServices';
import useD2C from "../../../hooks/useD2C";
import routes from "../../../constants/Routes";
import PreparationInstructionsModal from "./PreparationInstructionsModal";
import ExamineticsInstructionModal from "./ExamineticsInstructionModal";
import {useDispatch} from "react-redux";
import {resetEventData, setEventData} from "../../../features/askEmma/askEmmaSlice";
import {useHistory} from "react-router-dom";
import StrengthQuestion from "./PainQuestionForm/StrengthQuestion";
import examService from "../../../services/ExamService";
import RepCount from "./RepCount";
import AllDoneBtn from "./AllDoneBtn";
import './MovementCore.scss';
import {setShowDetailInstruction} from "../../../features/dashboard/dashboardSlice";
import AlertModal from "../AlertModal";
import audioManager from "../../../utils/AudioManager";
import SkipReasonModal from './SkipReasonModal';
import { useMovementFSM, useDetectionBridge, useMovementEffects, MovementState, MovementEvent } from './fsm';
import { useTenantFeatures } from '../../../features/tenantFeatures/useTenantFeature';

const MovementCore = ({testId, bodyRegionList, onClose, clearAndCloseChatbot}) => {
    const {
        deAuthenticate
    } = useContext(AppContext);

    const { videoFrameRate, videoResolutionWidth, videoResolutionHeight, isAthleteEnabled, isStrengthExerciseAICountEnable, isExamineticsEnabled, isStrengthExerciseAICountDisplayEnable, isMultiPersonDetectionEnable, isRealtimeFeedbackROMEnable, isSkipWhyRomQuestionEnable } = useTenantFeatures();
    const maxVideoFrameRate = Number(videoFrameRate) || 30;
    const maxVideoResolutionWidth = Number(videoResolutionWidth) || 1280;
    const maxVideoResolutionHeight = Number(videoResolutionHeight) || 720;

    const FACING_MODE_USER = "user";
    const FACING_MODE_ENVIRONMENT = "environment";

    const { storeUserInfoToLocalStorage } = useContext(AppContext);
    const { IsD2CEnabled } = useD2C();
    const dispatch = useDispatch();
    const history = useHistory();

    const [isVideoTopElementDisabled, setIsVideoTopElementDisabled] = useState(false);
    const [filteredExerciseList, setFilteredExerciseList] = useState([]);
    const [repCount, setRepCount] = useState(0);
    const [isShowNotificationAlert, setIsShowNotificationAlert] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [openRetakeNotificationModal, setOpenRetakeNotificationModal] = useState(false);
    const [isShowSelectMovementBox, setIsShowSelectMovementBox] = useState(true);
    const [isAnalyzingVideo, setIsAnalyzingVideo] = useState(false);
    const [isFullScreenVideo, setIsFullScreenVideo] = useState(false);
    const [EnableDetailedVoiceInstruction, setEnableDetailedVoiceInstruction] = useState(true);
    const [processingSaveAssessment, setProcessingSaveAssessment] = useState(false);
    const [isSkipping, setIsSkipping] = useState(false);
    const [isStrengthMovementSaving, setIsStrengthMovementSaving] = useState(false);
    const [isShowHeightForm, setIsShowHeightForm] = useState(false);
    const [isUpdatingUserData, setIsUpdatingUserData] = useState(false);
    const [isShowMovementList, setIsShowMovementList] = useState(false)
    const [showMovementGuideline, setShowMovementGuideline] = useState(false)
    const [messageOnVideo, setMessageOnVideo] = useState('');
    const [painQuestionList, setPainQuestionList] = useState([]);
    const [webcamConstraints, setWebcamConstraints] = useState({
        facingMode: FACING_MODE_USER,
        deviceId: "",
        width: maxVideoResolutionWidth,
        height: maxVideoResolutionHeight,
        frameRate: { min: maxVideoFrameRate, max: maxVideoFrameRate }
    });
    const [showPreparationInstructionModal, setShowPreparationInstructionModal] = useState(false);
    const [isShowExamineticsInstructionModal, setIsShowExamineticsInstructionModal] = useState(false);
    const [isShowRepCountModal, setIsShowRepCountModal] = useState(false);
    const [tempRepCount, setTempRepCount] = useState(0);
    const [currentExerciseForRepCount, setCurrentExerciseForRepCount] = useState(null);
    const [isSubmittingRepCount, setIsSubmittingRepCount] = useState(false);
    const [isShowSkipReasonModal, setIsShowSkipReasonModal] = useState(false);
    const [exerciseToSkip, setExerciseToSkip] = useState(null);
    const [windowHeaderTitle, setWindowHeaderTitle] = useState('');
    const [completionBioMessageTitle, setCompletionBioMessageTitle] = useState('Congratulations');
    const [isAssessmentComplete, setIsAssessmentComplete] = useState(false);
    const [isShowReviewDelayLoader, setIsShowReviewDelayLoader] = useState(false);
    const [showFakeProgress, setShowFakeProgress] = useState(false);
    const [showExamineticsFullBodyModal, setShowExamineticsFullBodyModal] = useState(false);
    const [fakeProgressValue, setFakeProgressValue] = useState(0);

    const isRepCountModalOpenRef = useRef(false);
    const isPreparationInstructionsModalOpenRef = useRef(false);

    const stateRef = useRef({
        prevPhase: null,
        currentPhase: null,
        reps: 0
    });
    const exerciseList = useRef([]);
    const realTimeDetectionConstrains = useRef({});
    const childExerciseExerciseCodeNameList = useRef([]);
    const measuredExerciseList = useRef([]);
    const selectedExercise = useRef({});
    const sweetAlertModalObj = useRef({});
    const retakeExercise = useRef({});
    const recordedBlob = useRef([]);
    const videoUrl = useRef('');
    const queuedMovements = useRef([]);
    const addedRemovedExercises = useRef({ addedExercises: [], removedExercises: []});
    const checkFullBodyInterval = useRef(null);
    const lastMovementPerformed = useRef(null);
    const retakeMovementList = useRef([]);
    const skippedMovementList = useRef([]);
    const shouldCheckMovementFinished = useRef(false);
    const completedPercentage = useRef(0);
    const videoRecordTime = useRef(5);
    const startUpdateExerciseList = useRef(false);
    const voiceEnable = useRef(true);
    const queueInterval = useRef(null);
    const notFoundAudioCounter = useRef(0);
    const patientNotFacingLeft = useRef(0);
    const patientNotFacingRight = useRef(0);
    const shoulderToShoulderDistance = useRef(0);
    const previousStatus = useRef('');
    const retakeModal = useRef(false);
    const percentageMessage = useRef('');
    const isPageLoaded = useRef(false);
    const isAutoRetakeMode = useRef(false);
    const isAutoRetakeFromModal = useRef(false);
    const autoRetakenExercisesRef = useRef(new Set());
    const isWaitingForResumeModalResponse = useRef(false);
    const isMovementPaused = useRef(false);
    const openVideoModal = useRef(false);
    const isCalibrationProcessing = useRef(false);
    const startRecording = useRef(false);
    const recordingStartTimeRef = useRef(null);
    const imperativeRecordingRef = useRef(null);
    // const notNeedGridExercisesRef = useRef(["floorLegsRaises"]);
    const notNeedSkipAndInMovementStatPopupExercisesRef = useRef(["floorLegsRaises"]);

    const movementRequirementsRef = useRef({
        isGoodLight: false,
        isMultiPerson: false,
        isReadyForCalibration: false,
        isCorrectOrientation: true,  // Default true (no orientation requirement)
    });
    const forceCloseReviewMovementModalRef = useRef(false);
    // add a ref to track the delay timeout
    const multiPersonResetTimeoutRef = useRef(null);
    const wasMultiPersonDetectedRef = useRef(false);
    const wasOutOfFrameRecordingStopRef = useRef(false);
    const visitedExercisesRef = useRef(new Set());
    const examineticsQueueStatusAppliedRef = useRef(false);
    const resetVideoPanelStateRef = useRef(null);

    const isAnyModalOpenRef = useRef(false);
    const selectingExerciseCodeRef = useRef(null); // lock to prevent duplicate onSelectNextMovement calls
    const isFSMFlowActiveRef = useRef(false); // true while FSM manages exercise flow (instruction→recording)
    const [exerciseGeneration, setExerciseGeneration] = useState(0); // increments on every exercise selection (including retake)

    // ── FSM ──
    const fsm = useMovementFSM();
    const { ref: detectionBridgeRef } = useDetectionBridge(fsm);

    const isAnyModalOpen =
        isShowNotificationAlert ||
        openRetakeNotificationModal ||
        isShowHeightForm ||
        showPreparationInstructionModal ||
        openVideoModal.current ||
        isShowExamineticsInstructionModal ||
        isShowRepCountModal ||
        isShowSkipReasonModal ||
        isShowReviewDelayLoader ||
        showFakeProgress ||
        isAssessmentComplete ||
        showExamineticsFullBodyModal;

    isAnyModalOpenRef.current = isAnyModalOpen;

    // Keep bridge values current (sync writes, no stale reads)
    detectionBridgeRef.current.isModalOpen = isAnyModalOpen;
    detectionBridgeRef.current.isMovementPaused = isMovementPaused.current;
    detectionBridgeRef.current.selectedExercise = selectedExercise.current;
    detectionBridgeRef.current.isExamineticsEnabled = isExamineticsEnabled;

    const checkIsLastExercise = (exerciseCodeName) => {
        if (!exerciseList.current || !exerciseCodeName) return false;
        const topLevelExercises = exerciseList.current.filter(x => !x["IsInMergeExercise"]);
        const remaining = topLevelExercises.filter(ex => 
            ex.ExerciseCodeName !== exerciseCodeName && 
            (ex.Status === CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name || 
             ex.Status === CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.key || 
             ex.Status === CONSTANT.EXERCISE_STATUS.RETAKE.name || 
             ex.Status === CONSTANT.EXERCISE_STATUS.RETAKE.key)
        );
        return remaining.length === 0;
    };

    // Actions bag for useMovementEffects
    const fsmActions = useMemo(() => ({
        playGeneralAudio: (audioKey) => {
            // Only gate WELCOME_TEXT when voice is off — other audio plays regardless
            const isWelcome = audioKey === CONSTANT.GENERAL_AUDIOS_KEY_TEXT.WELCOME_TEXT
                || audioKey === CONSTANT.GENERAL_AUDIOS_KEY_TEXT.STRENGTH_EXAMINETICS_WELCOME_TEXT;
            if (isWelcome && !voiceEnable.current) return;

            const audioUrl = getMessageByKeyText(realTimeDetectionConstrains.current, audioKey) || getAudioUrl(audioKey);
            if (audioUrl?.audio) {
                const priorityLevel = isWelcome ? 1 : 2;
                playAudioWithRetry(audioUrl.audio || audioUrl, { priorityLevel });
            } else if (typeof audioUrl === 'string') {
                playAudioWithRetry(audioUrl, { priorityLevel: 2 });
            }
        },
        playAudioWithRetry: (url, opts) => playAudioWithRetry(url, opts),
        isVoiceEnabled: () => voiceEnable.current,
        disableTopControls: () => setIsVideoTopElementDisabled(true),
        enableTopControls: () => setIsVideoTopElementDisabled(false),
        stopPlayingAudio: () => playAudio('remove'),
        getStartInstructionAudioUrl: () => {
            const msg = getMessageByKeyText(realTimeDetectionConstrains.current, 'START_INSTRUCTION');
            return msg?.audio || null;
        },
        getStartingMovementAudioUrl: () => {
            const msg = getMessageByKeyText(realTimeDetectionConstrains.current, 'STARTING_MOVEMENT');
            return msg?.audio || null;
        },
        onInstructionAudioComplete: () => {
            // FSM context update handled by reducer on INSTRUCTION_AUDIO_COMPLETE event
        },
        showCountdown: () => {
            setIsFullScreenVideo(true);
            setIsVideoTopElementDisabled(true);
        },
        hideCountdown: () => {
            setIsFullScreenVideo(false);
            setIsVideoTopElementDisabled(false);
        },
        startRecording: (duration) => {
            if (isAssessmentComplete) return;
            videoRecordTime.current = duration || getVideoLength(selectedExercise.current);
            if (imperativeRecordingRef.current) {
                imperativeRecordingRef.current(videoRecordTime.current);
            }
            startRecording.current = true;
            recordingStartTimeRef.current = Date.now();
        },
        stopRecording: () => {
            startRecording.current = false;
        },
        stopMultiPersonDetection: () => {
            // Handled by VideoPanel cleanup
        },
        playMultiPersonWarning: () => {
            // TODO: add multi-person warning audio
        },
        resetMovementLevelState: () => {
            movementRequirementsRef.current.isReadyForCalibration = false;
            movementRequirementsRef.current.isCorrectOrientation = true;
        },
        processRecordingResult: () => {
            // Actual processing happens in onStopVideoRecording callback
        },
        enableFeedbackAudio: () => {
            // FSM entered WAITING_FOR_USER_VALIDATION — detection bridge gates handle the rest
        },
        getAudioManager: () => audioManager,
    }), []);

    useMovementEffects(fsm, fsmActions);

    const clearAllIntervalsAndStopAudio = async () => {
        clearInterval(queueInterval.current);
        clearInterval(checkFullBodyInterval.current);
        forceStopAllAudio();
        queueInterval.current = null;
        checkFullBodyInterval.current = null;
        multiPersonResetTimeoutRef.current = null;
    }

    async function fetchData() {
        if (GLOBAL.DEVICE_WIDTH < 1000) {
            await renderPage();
        } else {
            let primaryDevice = await setPrimaryCamera();
            if (primaryDevice && !primaryDevice?.success) {
                showCameraAccessDeniedPopup();
                return;
            }

            const deviceDetails = primaryDevice?.deviceDetails || {};
            const maxWidth = primaryDevice?.maxWidth || 0;
            const maxHeight = primaryDevice?.maxHeight || 0;
            const cappedWidth = maxWidth > maxVideoResolutionWidth ? maxVideoResolutionWidth : (maxWidth || maxVideoResolutionWidth);
            const cappedHeight = maxHeight > maxVideoResolutionHeight ? maxVideoResolutionHeight : (maxHeight || maxVideoResolutionHeight);
            setWebcamConstraints({
                ...deviceDetails,
                width: cappedWidth,
                height: cappedHeight,
                frameRate: { min: maxVideoFrameRate, max: maxVideoFrameRate },
            });

            if (primaryDevice) {
                await renderPage();
            } else {
                sweetAlertModalObj.current = getSweetAlertModalConfig({
                    showCancelBtn: false,
                    showConfirmBtn: true,
                    alertType: 'info',
                    title: 'Not Found',
                    confirmBtnText: 'Ok, Got It',
                    cancelBtnText: '',
                    confirmBtnCss: 'btn btn-sm btn-success',
                    cancelBtnCss: 'btn btn-sm btn-danger',
                    message: 'Camera not found. Please check your camera permission and try again.',
                    closeOnOutsideClick: false,
                    onConfirm: closeCameraIssueSweetAlert
                });

                setIsShowNotificationAlert(true);
            }
        }
    }

    const showCameraAccessDeniedPopup = () => {
        let alertMessage = (
            <div>
                <p>Please check your camera permission and try again.</p>
                <img src={allowCameraImg} alt="MyImage" style={{width: "100%", height: "auto"}}/>
            </div>
        );
        sweetAlertModalObj.current = getSweetAlertModalConfig({
            showCancelBtn: false,
            showConfirmBtn: true,
            alertType: 'info',
            title: 'Camera not allowed',
            confirmBtnText: 'Ok, Got It',
            cancelBtnText: '',
            confirmBtnCss: 'btn btn-sm btn-success',
            cancelBtnCss: 'btn btn-sm btn-danger',
            message: alertMessage,
            closeOnOutsideClick: false,
            onConfirm: closeCameraIssueSweetAlert
        });
        setIsShowNotificationAlert(true);
    }

    const addEventListenerOnChangeCameraAccess = () => {
        navigator.permissions.query({name: 'camera'}).then(function (result) {
            result.addEventListener('change', function () {
                if (this.state === 'denied') {
                    showCameraAccessDeniedPopup();
                }
            });
        })
    }

    const closeCameraIssueSweetAlert = () => {
        setIsShowNotificationAlert(false);
        onClose && onClose();
    }

    const updateBiometricData = async (biometricData) => {
        setIsUpdatingUserData(true);
        await updateUserData(biometricData);

        GLOBAL.USER_INFO = {
            ...GLOBAL.USER_INFO,
            ...biometricData
        };

        setIsUpdatingUserData(false);
        setIsShowHeightForm(false);
        await startMovementOnHeightPresent();
    }

    const renderPage = async () => {
        setIsShowNotificationAlert(false);
        let measuredExercise = await getMeasuredExercises(testId, bodyRegionList);
        let realTimeDetectionResponse = await getRealTimeDetection(testId, [CONSTANT.MOVEMENT_TYPES.ROM]);
        if (!measuredExercise?.success || (measuredExercise?.data && measuredExercise?.data.length <= 0)) {
            toast.error(<div>Something went wrong please try again</div>);
            return;
        }
        if(!realTimeDetectionResponse) {
            toast.error(<div>Something went wrong please try again</div>);
            return;
        }
        realTimeDetectionConstrains.current = realTimeDetectionResponse;
        measuredExercise = measuredExercise?.data;
        queuedMovements.current = await getQueuedMovements(testId);
        addedRemovedExercises.current = await getAddedRemovedExercises(testId);
        // setFilteredExerciseList()
        // console.log( "i am from render-page component------------------------------------------", addedRemovedExercises.current);

        if (measuredExercise) {
            setWindowHeaderTitle(measuredExercise['WindowHeaderTitle'] || '');
            setCompletionBioMessageTitle(measuredExercise['CompletionBioMessageTitle'] || 'Congratulations');
            exerciseList.current = measuredExercise['MeasuredExercises'] || [];
            childExerciseExerciseCodeNameList.current = getChildrenValue(exerciseList.current);
            measuredExerciseList.current = measuredExercise['MeasuredExercises'] || [];

            // Extract biometric data from API response - Sole source of truth per requirement
            const height = measuredExercise['Height'];
            const weight = measuredExercise['Weight'];
            const dominantHand = measuredExercise['DominantHand'];
            const gender = measuredExercise['Gender'];

            // Update GLOBAL.USER_INFO with data from API only
            GLOBAL.USER_INFO = {
                ...GLOBAL.USER_INFO,
                Height: height || 0,
                Weight: weight || 0,
                DominantHand: dominantHand || '',
                Gender: gender || ''
            };

            // Check if height biometric data is present
            if (height && height > 0) {
                await startMovementOnHeightPresent();
            } else {
                setIsShowHeightForm(true);
            }
        }
    }

    const startMovementOnHeightPresent = async () => {
        if (exerciseList.current && exerciseList.current.length > 0) {
            if (queuedMovements.current && queuedMovements.current.length > 0 && !isExamineticsEnabled) {
                // Set flag to prevent welcome audio from playing on user interaction with modal
                isWaitingForResumeModalResponse.current = true;

                sweetAlertModalObj.current = getSweetAlertModalConfig({
                    showCancelBtn: true,
                    showConfirmBtn: true,
                    alertType: 'info',
                    title: 'Confirmation',
                    confirmBtnText: 'Yes, Resume',
                    cancelBtnText: 'No, Start Over',
                    confirmBtnCss: 'btn btn-sm btn-success',
                    cancelBtnCss: 'btn btn-sm btn-danger',
                    message: 'Do you want to resume your last assessment?',
                    closeOnOutsideClick: false,
                    onConfirm: onConfirmResume,
                    onCancel: onStartOver
                });
                setIsShowNotificationAlert(true);
            } else {
                // isPageLoaded, isDataLoaded, and DATA_LOADED event are handled
                // inside onSelectNextMovement — same path for all tenants.
                await onConfirmResume();
            }
        }
    }

    const startMovementRendering = async () => {
        lastMovementPerformed.current = getLastPerformedMovement(exerciseList.current, null);
        if (!isExamineticsEnabled && exerciseList.current.length > 0) {
            exerciseList.current = setMovementStatus(exerciseList.current, exerciseList.current[0], CONSTANT.EXERCISE_STATUS.PERFORMING.key);
        }

        setIsShowNotificationAlert(false);

        if (queuedMovements.current) {
            startUpdateExerciseList.current = true;
            await updateExerciseListAndIsUserCanSkipExercisesStatus();
        }

        // console.log('onSelectNextMovement 1')

        if (isExamineticsEnabled) {
            completedPercentage.current = await calculateTotalCompletedPercentage();
            if (completedPercentage.current >= 100) {
                setShowPreparationInstructionModal(false);
                isPreparationInstructionsModalOpenRef.current = false;
            }
            await onClickSelect();
        } else {
            if (exerciseList.current.length > 0) {
                await onSelectNextMovement(exerciseList.current[0]);
            }
        }
        completedPercentage.current = await calculateTotalCompletedPercentage();

        if (isExamineticsEnabled && completedPercentage.current >= 100) {
            setIsDataLoaded(true);
            isPageLoaded.current = true;
            return;
        }

        setIsShowNotificationAlert(false);
    }

    const onConfirmResume = async () => {
        // Clear the flag so welcome audio can play in startMovementRendering
        isWaitingForResumeModalResponse.current = false;

        for (let i = 0; i < exerciseList.current.length; i++) {
            let isCompletedInQueue = false;
            if (isExamineticsEnabled && queuedMovements.current) {
                const queuedEx = queuedMovements.current.find(q => q.exerciseName === exerciseList.current[i].ExerciseCodeName);
                if (queuedEx && queuedEx.status === CONSTANT.EXERCISE_STATUS.COMPLETED.key) {
                    isCompletedInQueue = true;
                }
            }

            if (isExamineticsEnabled && isCompletedInQueue) {
                exerciseList.current = setMovementStatus(exerciseList.current, exerciseList.current[i], CONSTANT.EXERCISE_STATUS.COMPLETED.key);
                visitedExercisesRef.current.add(exerciseList.current[i].ExerciseCodeName);
                continue;
            }

            let status = CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name;
            let exercise = exerciseList.current[i];
            if (exercise.IsSkipExercise) {
                status = CONSTANT.EXERCISE_STATUS.SKIPPED.key;
            }
            exerciseList.current = setMovementStatus(exerciseList.current, exerciseList.current[i], status);
        }
        const totalPercentage = await calculateTotalCompletedPercentage();
        if (isExamineticsEnabled && totalPercentage >= 100) {
            setShowPreparationInstructionModal(false);
            isPreparationInstructionsModalOpenRef.current = false;
        } else {
            setShowPreparationInstructionModal(true);
            isPreparationInstructionsModalOpenRef.current = true;
        }
        GLOBAL.AUDIO_PLAY_ENABLED = true;
        await startMovementRendering();
    }

    const onStartOver = async () => {
        // Clear the flag so welcome audio can play in startMovementRendering
        isWaitingForResumeModalResponse.current = false;

        let response = await callStartOverApi(testId, getPatientId());//VA PORTAL API
        if (response) {
            queuedMovements.current = [];
            if (isExamineticsEnabled) {
                examineticsQueueStatusAppliedRef.current = false;
            }
            exerciseList.current.forEach(exercise => {
                exercise.Status = CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name;
            });

            setShowPreparationInstructionModal(true);
            isPreparationInstructionsModalOpenRef.current = true;
            GLOBAL.AUDIO_PLAY_ENABLED = true;
            await startMovementRendering();
        }
    }

    const toggleIsUserCanSkipExerciseProcessingAlert = async (isNeedOpen) => {
        if (!isNeedOpen) {
            if (isExamineticsEnabled && completedPercentage.current >= 100) {
                setIsShowNotificationAlert(false);
                return;
            }
            setIsShowNotificationAlert(false);
            await onClickSelect();
        } else {
            let alertMsg = 'Please wait. The system is calibrating to your height. We must finish this process before taking the remainder of your measurements';
            if (selectedExercise.current?.ExerciseCodeName !== CONSTANT.EXERCISES_NAME.calibration) {
                alertMsg = 'Please wait for the movement to be processed.';
            }

            sweetAlertModalObj.current = getSweetAlertModalConfig({
                showCancelBtn: false,
                showConfirmBtn: false,
                alertType: 'warning',
                title: selectedExercise.current?.ExerciseDisplayName || '',
                confirmBtnText: '',
                cancelBtnText: '',
                confirmBtnCss: '',
                cancelBtnCss: '',
                message: `${alertMsg}`,
                closeOnOutsideClick: false
            });
            setIsShowNotificationAlert(true);
            if (EnableDetailedVoiceInstruction) {
                await playGeneralAudio(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.WAIT_UNTIL_CALIBRATION_FINISHED);
            }
        }
    }

    const updateExerciseListAndIsUserCanSkipExercisesStatus = async () => {
        if (isExamineticsEnabled && examineticsQueueStatusAppliedRef.current) {
            return;
        }
        if (isExamineticsEnabled) {
            examineticsQueueStatusAppliedRef.current = true;
        }

        let exListObj = await updateExerciseList(queuedMovements.current, exerciseList.current);
        let selectedExerciseUpdated = exListObj.exerciseList
            .filter(exercise => exercise?.ExerciseCodeName === selectedExercise.current?.ExerciseCodeName);
        let statusOfSelectedExercise;
        if (selectedExerciseUpdated.length > 0) {
            statusOfSelectedExercise = selectedExerciseUpdated[0]?.Status;
        }

        // Don't let queue interval advance exercises while FSM is managing the flow
        // (instruction audio playing, detection, countdown, recording).
        // Only update the exercise list itself.
        if (isFSMFlowActiveRef.current) {
            exerciseList.current = exListObj.exerciseList;
            setFilteredExerciseList(prev => exerciseList.current.slice());
            return;
        }

        if (
            !selectedExercise.current?.IsUserCanSkip && (
                (statusOfSelectedExercise === CONSTANT.EXERCISE_STATUS.COMPLETED.key) ||
                (statusOfSelectedExercise === CONSTANT.EXERCISE_STATUS.RETAKE_HUMAN_EXPERT.key)
            )
        ) {
            if (selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.STRENGTH || selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID) {
                return;
            }

            isCalibrationProcessing.current = false;
            await toggleIsUserCanSkipExerciseProcessingAlert(isCalibrationProcessing.current);
        } else if (!isRepCountModalOpenRef.current &&
            !selectedExercise.current?.IsUserCanSkip &&
            statusOfSelectedExercise === CONSTANT.EXERCISE_STATUS.RETAKE.key &&
            selectedExercise.current?.ExerciseTypeId !== CONSTANT.MOVEMENT_TYPES.STRENGTH && selectedExercise.current?.ExerciseTypeId !== CONSTANT.MOVEMENT_TYPES.HYBRID) {
            exerciseList.current = setMovementStatus(exerciseList.current, exerciseList.current[0], CONSTANT.EXERCISE_STATUS.RETAKE.name)
            setFilteredExerciseList(prev => exerciseList.current.slice());
            let currentExercise = exerciseList.current.find((exercise) => exercise.ExerciseCodeName === selectedExercise.current?.ExerciseCodeName);

            // console.log('onSelectNextMovement 2')
            await onSelectNextMovement(currentExercise);
            // sweetAlertModalObj.current = getSweetAlertModalObj(false, true, 'info', `Retake ${selectedExercise.current?.ExerciseDisplayName}`, 'Ok', '','btn btn-sm btn-success','',`${selectedExercise.current?.ExerciseDisplayName} was not successful, please re-retry.`, false, handleCloseIsUserCanSkipExercisesRetakeSweetAlert);
            sweetAlertModalObj.current = getSweetAlertModalConfig({
                showCancelBtn: false,
                showConfirmBtn: true,
                alertType: 'info',
                title: `Retake ${selectedExercise.current?.ExerciseDisplayName || ''}`,
                confirmBtnText: 'Ok',
                cancelBtnText: '',
                confirmBtnCss: 'btn btn-sm btn-success',
                cancelBtnCss: '',
                message: `${selectedExercise.current?.ExerciseDisplayName || ''} was not successful, please retry.`,
                closeOnOutsideClick: false,
                onConfirm: handleCloseIsUserCanSkipExercisesRetakeSweetAlert
            });
            setIsShowNotificationAlert(true);
            isCalibrationProcessing.current = false;
        }
        exerciseList.current = exListObj.exerciseList;
        setFilteredExerciseList(prev => exerciseList.current.slice());
    }

    const handleCloseIsUserCanSkipExercisesRetakeSweetAlert = async () => {
        setIsShowNotificationAlert(false)
        let currentExercise = exerciseList.current.find((exercise) => exercise.ExerciseCodeName === selectedExercise.current?.ExerciseCodeName);

        // console.log('onSelectNextMovement 3')
        await onSelectNextMovement(currentExercise, true);
    }

    const playGeneralAudio = async (audioKey) => {
        await stopPlayingAudio();

        let audioUrl = "";
        
        if (realTimeDetectionConstrains.current) {
            const generalMsg = getMessageByKeyTexts(realTimeDetectionConstrains.current, "general", audioKey);
            if (generalMsg && generalMsg.audio) {
                audioUrl = generalMsg.audio;
            }
        }
        
        // Fallback to GLOBAL.GENERAL_AUDIOS
        if (!audioUrl) {
            audioUrl = getAudioUrl(audioKey);
        }

        if (audioUrl) {
            // Assign priority levels: WELCOME_TEXT = 1 (highest), others = 2 (medium)
            const priorityLevel = (audioKey === CONSTANT.GENERAL_AUDIOS_KEY_TEXT.WELCOME_TEXT || audioKey === CONSTANT.GENERAL_AUDIOS_KEY_TEXT.STRENGTH_EXAMINETICS_WELCOME_TEXT) ? 1 : 2;
            await playAudioWithRetry(audioUrl, { priorityLevel });
        } else {
            console.log('No audio URL found for key:', audioKey);
        }
    }

    const stopPlayingAudio = async () => {
        await playAudio('remove');
    }


    const playPatientNotInBoxAudio = async () => {
        // const congratsData = getMessageByKeyText(realTimeDetectionConstrains.current, 'RomCongratulations');
        // const audioUrlFullBodyNegative = getAudioUrl(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.FULL_BODY_NEGATIVE);
        const audioUrlFullBodyNegative = getMessageByKeyText(realTimeDetectionConstrains.current, 'FULL_BODY_NEGATIVE');
        const audioUrlTakeBrake = getAudioUrl(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.TAKE_BRAKE);

        if (!audioUrlFullBodyNegative) return;

        notFoundAudioCounter.current++;
        await playAudio(audioUrlFullBodyNegative.audio);

        if (notFoundAudioCounter.current === 4 && audioUrlTakeBrake) {
            await playAudio(audioUrlTakeBrake, { priorityLevel: 3 });
        }
    }

    const checkAndPlayAudio = async () => {
        if ((
            isAnyModalOpenRef.current ||
            isMovementPaused.current ||
            isAssessmentComplete
        )) return;

        // Block all warning audios until movement-specific instruction audio has played
        if (!fsm.context.instructionAudioPlayed) return;

        const shouldUserFaceLeft = doesUserNeedFacingLeft(selectedExercise.current);
        const shouldUserFaceRight = doesUserNeedFacingRight(selectedExercise.current);

        const isActivelyRecording = startRecording.current;
        const isCountdownActive = fsm.isIn(MovementState.RUNNING_PRE_RECORDING_COUNTDOWN);
        const isWaitingForCountdown = fsm.isIn(MovementState.USER_READY_FOR_PRE_RECORDING);
        const isFlowActive = fsm.currentState !== MovementState.IDLE &&
            fsm.currentState !== MovementState.SHOWING_WELCOME_INSTRUCTION &&
            fsm.currentState !== MovementState.SHOWING_MOVEMENT_INSTRUCTION &&
            fsm.currentState !== MovementState.WAITING_FOR_PERSON_IN_BOX;
        const isWelcomeDone = fsm.currentState !== MovementState.SHOWING_WELCOME_INSTRUCTION;

        const shouldPlayAudio =
            (isFlowActive || isCountdownActive || isActivelyRecording || isWaitingForCountdown) &&
            isWelcomeDone &&
            (
                (!GLOBAL.IS_PATIENT_IN_BOX && notFoundAudioCounter.current < 4) ||
                (shouldUserFaceLeft && GLOBAL.IS_PATIENT_IN_BOX && !GLOBAL.IS_PATIENT_FACING_LEFT && patientNotFacingLeft.current < 4) ||
                (shouldUserFaceRight && GLOBAL.IS_PATIENT_IN_BOX && !GLOBAL.IS_PATIENT_FACING_RIGHT && patientNotFacingRight.current < 4)
            )
        ;

        if (shouldPlayAudio && GLOBAL.IsColorRedForFullBox && !(isExamineticsEnabled && startRecording.current)) {
            await stopPlayingAudio();
            if (!GLOBAL.IS_PATIENT_IN_BOX) {
                if (!isExamineticsEnabled) {
                    await playAudio("remove");
                    await playPatientNotInBoxAudio();
                }
            } else if (shouldUserFaceRight && !GLOBAL.IS_PATIENT_FACING_RIGHT) {
                await playAudio("remove");
                patientNotFacingRight.current++;
                await playPatientNotStandingFacingRight();
            } else if (shouldUserFaceLeft && !GLOBAL.IS_PATIENT_FACING_LEFT) {
                await playAudio("remove");
                patientNotFacingLeft.current++;
                await playPatientNotStandingFacingLeft();
            }
        }
    }

    const storePreviousStatus = (exStatus) => {
        if (exStatus !== CONSTANT.EXERCISE_STATUS.PERFORMING.key) {
            previousStatus.current = exStatus;
        }
    }

    const startExamineticsExercise = async () => {
        setIsShowExamineticsInstructionModal(false);
        setIsVideoTopElementDisabled(false);

        fsm.send(MovementEvent.INSTRUCTION_DISMISSED, {
            selectedExercise: selectedExercise.current,
            videoDuration: videoRecordTime.current,
        });
    }

    const performLaterExamineticsExercise = async () => {
        forceStopAllAudio();
        setIsShowExamineticsInstructionModal(false);
        setIsVideoTopElementDisabled(false);
        
        let shouldCallNotificationDirectly = false;

        const currentExercise = selectedExercise.current;
        if (currentExercise) {
            // Set status to 'Not Performed' as requested, but track it as visited for this pass
            exerciseList.current = setMovementStatus(exerciseList.current, currentExercise, CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name);
            visitedExercisesRef.current.add(currentExercise.ExerciseCodeName);

            // Move the current exercise to the end of the list to ensure the user moves on
            const index = exerciseList.current.findIndex(ex => ex.ExerciseCodeName === currentExercise.ExerciseCodeName);
            if (index > -1) {
                const [exercise] = exerciseList.current.splice(index, 1);
                exerciseList.current.push(exercise);
            }

            // Check if there are any *other* NOT_PERFORMED or RETAKE exercises left to switch to.
            // If this is the only one, hitting 'Perform Later' means we've effectively finished the queue for now.
            const otherNotPerformed = exerciseList.current.filter(ex => 
                (ex.Status === CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name ||
                 ex.Status === CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.key ||
                 ex.Status === CONSTANT.EXERCISE_STATUS.RETAKE.name ||
                 ex.Status === CONSTANT.EXERCISE_STATUS.RETAKE.key) && 
                ex.ExerciseCodeName !== currentExercise.ExerciseCodeName && 
                !ex["IsInMergeExercise"]
            );
            
            if (otherNotPerformed.length === 0) {
                shouldCallNotificationDirectly = true;
            }

            setFilteredExerciseList(exerciseList.current.slice());
        }

        if (shouldCallNotificationDirectly) {
            await clearIntervalAndStopAudio(checkFullBodyInterval.current, null, stopPlayingAudio);
            shouldCheckMovementFinished.current = true;
            await controlWithNotificationModal();
        } else {
            await onClickSelect();
        }
    }

    const onSelectNextMovement = async (exercise, isRetake = false) => {
        // Synchronous lock — prevents queue interval race where second call
        // arrives during async gap (await) of the first call
        const code = exercise?.ExerciseCodeName;
        if (!isRetake && selectingExerciseCodeRef.current === code) {
            console.log('[FSM] skipping duplicate EXERCISE_SELECTED for', code);
            return;
        }
        selectingExerciseCodeRef.current = code;
        isFSMFlowActiveRef.current = true; // Block queue interval from advancing
        setExerciseGeneration(prev => prev + 1); // Signal VideoPanel to reset detection state
        console.log('[TRACE] onSelectNextMovement called for', code, 'isRetake:', isRetake);
        console.trace('[TRACE] onSelectNextMovement caller');

        if (isExamineticsEnabled && exercise?.ExerciseCodeName) {
            visitedExercisesRef.current.add(exercise.ExerciseCodeName);
        }

        // FSM: send EXERCISE_SELECTED to reset flow for new exercise
        fsm.send(MovementEvent.EXERCISE_SELECTED, {
            exercise,
            videoDuration: getVideoLength(exercise),
            hasNextExercise: false, // Will be computed later
        });

        if (!exercise?.IsMeasurementNeeded) {
            GLOBAL.DRAW_BOX = false;
        } else {
            GLOBAL.DRAW_BOX = true;
        }

        if (exercise && Object.keys(exercise).length > 0) {
            // clear question answers for next exercise
            if (exercise?.PainQuestions?.length) {
                exercise.PainQuestions.forEach(q => {
                    q.AnswerList = [];
                    q.AnswerId = 0;
                });
            }

            setIsFullScreenVideo(false);
            startRecording.current = false;
            setIsVideoTopElementDisabled(false);
            // Audio lifecycle managed by FSM effects — stopPlayingAudio() here
            // kills instruction audio when onSelectNextMovement is called twice
            // (e.g. queue interval race). playAudioWithRetry stops old audio internally.
            let exStatus = exercise.Status;
            exerciseList.current = await setStatusOfSelectedExercise(exerciseList.current, previousStatus.current, exercise, selectedExercise.current, isRetake, isExamineticsEnabled);
            storePreviousStatus(exStatus);
            toggleShowMovementBox(true);
            shouldCheckMovementFinished.current = false;
            setOpenRetakeNotificationModal(false);
            selectedExercise.current = exercise;
            setFilteredExerciseList(prev => exerciseList.current.slice());

            // If strength exercise, handle special flow based on AI count setting
            if ((exercise?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.STRENGTH || exercise?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID) &&
                !isStrengthExerciseAICountEnable && !isExamineticsEnabled) {

                // Stop any playing audio
                await stopPlayingAudio();

                // Disable UI interactions during modal
                setIsVideoTopElementDisabled(true);

                // Show rep count modal for manual entry
                setTempRepCount(0);
                setCurrentExerciseForRepCount(exercise);
                setIsSubmittingRepCount(false);
                setIsShowRepCountModal(true);

                return; // Exit early - skip recording flow
            }

            if (!isPageLoaded.current) {
                isPageLoaded.current = true;
                setIsDataLoaded(true);
                GLOBAL.AUDIO_PLAY_ENABLED = true;

                // Fire FSM DATA_LOADED event to transition from IDLE
                fsm.send(MovementEvent.DATA_LOADED, {
                    isExamineticsEnabled,
                    isMultiPersonDetectionEnable,
                    isRealtimeFeedbackROMEnable,
                    hasSeenInstructions: !isPreparationInstructionsModalOpenRef.current,
                    selectedExercise: selectedExercise.current,
                    videoDuration: videoRecordTime.current,
                });
            }

            if (isExamineticsEnabled) {
                setIsVideoTopElementDisabled(true);
                // ONLY show the examinetics modal if preparation modal is NOT open and NOT about to be open
                if (!isPreparationInstructionsModalOpenRef.current && !showPreparationInstructionModal) {
                    setIsShowExamineticsInstructionModal(true);
                }
                return;
            }

            // FSM effects handle instruction audio playback on SHOWING_MOVEMENT_INSTRUCTION
            notFoundAudioCounter.current = 0;
        }
    }

    const onClickSelect = async () => {
        if (isExamineticsEnabled) {
            const topLevelExercises = exerciseList.current.filter(x => !x["IsInMergeExercise"]);
            if (visitedExercisesRef.current.size >= topLevelExercises.length) {
                await clearIntervalAndStopAudio(checkFullBodyInterval.current, null, stopPlayingAudio);
                if (selectedExercise.current && selectedExercise.current.Status === CONSTANT.EXERCISE_STATUS.PERFORMING.key) {
                    exerciseList.current = setMovementStatus(exerciseList.current, selectedExercise.current, CONSTANT.EXERCISE_STATUS.COMPLETED.key);
                }
                setFilteredExerciseList(prev => exerciseList.current.slice());
                shouldCheckMovementFinished.current = true;
                await controlWithNotificationModal();
                return;
            }
        }
        let exercise = await getNextMovement(exerciseList.current);
        if (exercise?.ExerciseCodeName) {
            await onSelectNextMovement(exercise);
        } else {
            await clearIntervalAndStopAudio(checkFullBodyInterval.current, null, stopPlayingAudio);
            if (selectedExercise.current && selectedExercise.current.Status === CONSTANT.EXERCISE_STATUS.PERFORMING.key) {
                let targetStatus = isExamineticsEnabled ? CONSTANT.EXERCISE_STATUS.COMPLETED.key : CONSTANT.EXERCISE_STATUS.WAITING.key;
                exerciseList.current = setMovementStatus(exerciseList.current, selectedExercise.current, targetStatus);
            }
            setFilteredExerciseList(prev => exerciseList.current.slice());
            shouldCheckMovementFinished.current = true;
            await controlWithNotificationModal();
        }
    }

    const onClosePauseNotification = async () => {
        isMovementPaused.current = false;
        setIsShowNotificationAlert(false);

        await onSelectNextMovement(selectedExercise.current);
    }

    const onClickPauseBtn = async () => {
        await clearIntervalAndStopAudio(checkFullBodyInterval.current, null, stopPlayingAudio);
        sweetAlertModalObj.current = getSweetAlertModalConfig({
            showCancelBtn: false,
            showConfirmBtn: true,
            alertType: 'warning',
            title: 'Movement Paused',
            confirmBtnText: 'Start Again',
            cancelBtnText: '',
            confirmBtnCss: 'btn btn-sm btn-success',
            cancelBtnCss: '',
            message: 'The movement has been paused',
            closeOnOutsideClick: false,
            onConfirm: onClosePauseNotification
        });
        isMovementPaused.current = true;
        setIsShowNotificationAlert(true);
    }

    const processStrengthMovements = async (exercise) => {
        // Use AI-counted reps if feature is enabled, otherwise default to 0 for manual entry
        const initialRepCount = isStrengthExerciseAICountEnable ? stateRef.current.reps : 0;

        // Skip confirmation modal for Examinetics population
        if (isExamineticsEnabled && (exercise?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.STRENGTH || exercise?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID)) {
            await submitStrengthReps(exercise, initialRepCount);
            return;
        }

        setTempRepCount(initialRepCount);
        setIsSubmittingRepCount(false);
        setCurrentExerciseForRepCount(exercise);
        setOpenRetakeNotificationModal(false);
        shouldCheckMovementFinished.current = false;

        await clearIntervalAndStopAudio(checkFullBodyInterval.current, null, stopPlayingAudio);

        isRepCountModalOpenRef.current = true;
        setIsShowRepCountModal(true);

        const isVoiceEnabled = GLOBAL.TENANT_FEATURES.find(
            item => item.Name === "IsBiometricVoiceInteractionEnable"
        )?.Value === "True";

        const { audio } = getMessageByKeyTexts(
            realTimeDetectionConstrains.current,
            "BiometricVoiceInteraction",
            "repsConfirmation"
        ) || {};

        if (audio && isVoiceEnabled) {
            await playAudio(audio);
        }
    };

    const submitStrengthReps = async (exercise, reps) => {
        setIsSubmittingRepCount(true);

        try {
            const payload = {
                Tenant: GLOBAL.TENANT,
                TestId: testId,
                ExerciseValue: exercise?.ExerciseCodeName,
                RepetitionCount: reps || 0
            };

            stateRef.current = {
                prevPhase: null,
                currentPhase: null,
                reps: 0
            };

            let response = { success: true };
            if (exercise?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.STRENGTH) {
                response = await examService.strengthExerciseMovement(payload);
            }
            // const response = await examService.strengthExerciseMovement(payload);
            if (response && !response.success && response.message) {
                toast.error(
                    <div>{response.message ? response.message : "Unable to analyze the video. Please try again later."}</div>
                );
            }

            // For HYBRID exercises, also send to the Enqueue processing backend
            if (exercise?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID && recordedBlob.current) {
                const base64Image = await convertToBase64(recordedBlob.current);
                const isMeasurementNeeded = exercise['IsMeasurementNeeded'] ? exercise['IsMeasurementNeeded'] : false;
                
                const hybridPayload = {
                    tenant: GLOBAL.TENANT,
                    testId: testId,
                    codeName: exercise?.ExerciseCodeName,
                    repetitionCount: reps || 0,
                    mediaData: base64Image
                };

                const isLast = checkIsLastExercise(exercise?.ExerciseCodeName);

                if (isLast) {
                    await Promise.all([
                        processExerciseVideo(testId, exercise?.ExerciseCodeName, isMeasurementNeeded, base64Image, exercise?.ExerciseTypeId, reps || 0),
                        // examService.saveHybridExerciseData(hybridPayload)
                    ]);
                } else {
                    Promise.all([
                        processExerciseVideo(testId, exercise?.ExerciseCodeName, isMeasurementNeeded, base64Image, exercise?.ExerciseTypeId, reps || 0),
                        // examService.saveHybridExerciseData(hybridPayload)
                    ]);
                }
            }


            setIsShowRepCountModal(false);
            isRepCountModalOpenRef.current = false;

            // Re-enable UI if it was disabled
            setIsVideoTopElementDisabled(false);

            // Move to next exercise after submission
            await onClickSelect();
        } finally {
            setIsSubmittingRepCount(false);
        }
    };

    const handleRepCountSubmit = async () => {
        await submitStrengthReps(currentExerciseForRepCount, tempRepCount);
    };

    const handleRepCountChange = (e) => {
        const value = e.target.value;
        // Allow only numbers
        if (value === '' || /^\d+$/.test(value)) {
            setTempRepCount(value === '' ? 0 : parseInt(value, 10));
        }
    };

    const onClickSkip = async (exercise) => {
        if (exercise && Object.keys(exercise).length > 0) {
            await stopPlayingAudio();
            setIsSkipping(true);
            setIsVideoTopElementDisabled(true);
            setIsFullScreenVideo(false);

            if (exercise?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.STRENGTH || exercise?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID) {
                try {
                    const payload = {
                        Tenant: GLOBAL.TENANT,
                        TestId: testId,
                        ExerciseValue: exercise?.ExerciseCodeName,
                        RepetitionCount: 0,
                        IsSkip: true
                    };

                    let response = { success: true };
                    response = await examService.strengthExerciseMovement(payload);
                    // const response = await examService.strengthExerciseMovement(payload);

                    if (response.success) {
                        exerciseList.current = setMovementStatus(exerciseList.current, selectedExercise, CONSTANT.EXERCISE_STATUS.SKIPPED.key);

                        setFilteredExerciseList(prev => exerciseList.current.slice());
                        await onClickSelect();
                    }
                } catch (error) {
                    console.error("Error submitting strength question:", error);
                    // You might want to show an error message to the user here
                }
            } else {
                const result = await skipMovement(exerciseList.current, exercise, CONSTANT.PROVIDER_EMAIL, testId);
                if (result?.success) {
                    exerciseList.current = setMovementStatus(exerciseList.current, exercise, CONSTANT.EXERCISE_STATUS.SKIPPED.key);
                    setFilteredExerciseList(prev => exerciseList.current.slice());
                } else {
                    toast.error(<div>Unable to skip the movements</div>);
                }

                await onClickSelect();
            }

            setIsSkipping(false);
            setIsVideoTopElementDisabled(false);
            setIsShowNotificationAlert(false);
        }
    }

    const handleClickUnableToPerform = async (exercise) => {
        if (notNeedSkipAndInMovementStatPopupExercisesRef.current.includes(exercise.ExerciseCodeName)) {
            await onClickSkip(exercise);
            return;
        }

        if (isSkipWhyRomQuestionEnable && exercise?.SkipWhyQuestions && exercise.SkipWhyQuestions.length > 0) {
            setExerciseToSkip(exercise);
            setIsShowSkipReasonModal(true);
            await clearIntervalAndStopAudio(checkFullBodyInterval.current, null, stopPlayingAudio);
            return;
        }

        sweetAlertModalObj.current = getSweetAlertModalConfig({
            showCancelBtn: true,
            showConfirmBtn: true,
            alertType: 'warning',
            title: 'Unable to Perform',
            confirmBtnText: 'Yes',
            cancelBtnText: 'No',
            confirmBtnCss: 'btn btn-sm btn-success',
            cancelBtnCss: 'btn btn-sm btn-danger',
            message: 'Are you sure you would like to skip this movement?',
            closeOnOutsideClick: false,
            onConfirm: () => onClickSkip(exercise), // Assuming `exercise` is in scope where this is called
            onCancel: () => {
                setIsShowNotificationAlert(false)
            },
            processingConfirmText: 'Skipping...'
        });
        await clearIntervalAndStopAudio(checkFullBodyInterval.current, null, stopPlayingAudio);
        setIsShowNotificationAlert(true);
    }

    const handleSkipReasonSubmit = async (answer) => {
        setIsShowSkipReasonModal(false);
        setIsVideoTopElementDisabled(true);
        setIsSkipping(true);
        await stopPlayingAudio();
        setIsFullScreenVideo(false);

        const response = await saveSkipReasonQuestions(answer, CONSTANT.PROVIDER_EMAIL, testId, bodyRegionList);
        if (response) {
            if (exerciseToSkip.SkipWhyQuestions && exerciseToSkip.SkipWhyQuestions.length > 0) {
                exerciseToSkip.SkipWhyQuestions[0].AnswerId = answer.AnswerId;
            }
            exerciseList.current = setMovementStatus(exerciseList.current, exerciseToSkip, CONSTANT.EXERCISE_STATUS.SKIPPED.key);
            setFilteredExerciseList(prev => exerciseList.current.slice());
            await onClickSelect();
        } else {
            toast.error(<div>Unable to skip the movements</div>);
        }

        setExerciseToSkip(null);
        setIsSkipping(false);
        setIsVideoTopElementDisabled(false);
    }

    const handleClickAllDone = async (exercise) => {
        setIsStrengthMovementSaving(true);
        setIsVideoTopElementDisabled(true);

        GLOBAL.IsColorRedForFullBox = true;
        await stopPlayingAudio();
        setIsFullScreenVideo(false);
        startRecording.current = false;

        if (exercise?.ExerciseCodeName === CONSTANT.EXERCISES_NAME.pushUpMale || exercise?.ExerciseCodeName === CONSTANT.EXERCISES_NAME.pushUpFemale) {
            setPainQuestionList(exercise?.PainQuestions || []);
            openVideoModal.current = false;

            await processStrengthMovements(exercise);
        }

        setIsStrengthMovementSaving(false);
        setIsVideoTopElementDisabled(false);
    }

    const onCancelSaveAndClose = () => {
        setIsShowNotificationAlert(false);
        setOpenRetakeNotificationModal(false);
    }

    const clearAllActiveProperty = () => {
        voiceEnable.current = false;
        setEnableDetailedVoiceInstruction(false);
        GLOBAL.AUDIO_PLAY_ENABLED = false;
        shouldCheckMovementFinished.current = false;
        isAutoRetakeMode.current = false;
        isAutoRetakeFromModal.current = false;
        autoRetakenExercisesRef.current.clear();
    }

    const onConfirmSaveAndClose = async () => {
        clearAllActiveProperty();
        await clearAllIntervalsAndStopAudio();
        setProcessingSaveAssessment(true);
        setProcessingSaveAssessment(false);
        setIsShowNotificationAlert(false);

        dispatch(resetEventData());
        onClose && onClose();
    }

    const onConfirmSaveByClick = async () => {
        await clearAllIntervalsAndStopAudio();
        onConfirmSaveAndClose();
    }

    const onClickSaveAndCloseBtn = async () => {
        let totalCompletedPercentage = await calculateTotalCompletedPercentage();
        if (totalCompletedPercentage < 100) {
            sweetAlertModalObj.current = getSweetAlertModalConfig({
                showCancelBtn: true,
                showConfirmBtn: true,
                alertType: 'warning',
                title: 'Warning',
                confirmBtnText: 'Yes',
                cancelBtnText: 'No',
                // confirmBtnCss: 'btn btn-sm btn-success',
                // cancelBtnCss: 'btn btn-sm btn-danger',
                message: 'You did not complete performing all movements. Do you want to save without those movements?',
                closeOnOutsideClick: false,
                onConfirm: onConfirmSaveByClick,
                onCancel: onCancelSaveAndClose
            });

            setIsShowNotificationAlert(true);
        } else {
            await onConfirmSaveAndClose();
        }
    }

    const calculateTotalCompletedPercentage = async () => {
        let totalCompletedPercentage = await getTotalCompletedPercentage(exerciseList.current,
            CONSTANT.EXERCISE_STATUS.COMPLETED.key,
            CONSTANT.EXERCISE_STATUS.RETAKE_HUMAN_EXPERT.key,
            CONSTANT.EXERCISE_STATUS.SKIPPED.key);

        return totalCompletedPercentage;
    }

    const openMovementPercentageModal = async (isBypassPreparationModalCheck = false) => {
        let totalCompletedPercentage = await calculateTotalCompletedPercentage();

        if (totalCompletedPercentage < 100) {
            if (isExamineticsEnabled) {
                const hasActionableMovements = exerciseList.current.some(ex =>
                    ex.Status === CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name ||
                    ex.Status === CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.key ||
                    ex.Status === CONSTANT.EXERCISE_STATUS.RETAKE.name ||
                    ex.Status === CONSTANT.EXERCISE_STATUS.RETAKE.key
                );
                if (!hasActionableMovements) {
                    return;
                }
            }
            let waitingMovements = await getMovementsOfSelectedStatus(exerciseList.current, CONSTANT.EXERCISE_STATUS.WAITING.key) || [];
            let processingMovements = await getMovementsOfSelectedStatus(exerciseList.current, CONSTANT.EXERCISE_STATUS.PROCESSING.key) || [];
            retakeMovementList.current = waitingMovements.concat(processingMovements);
            retakeModal.current = false;
            percentageMessage.current = totalCompletedPercentage + '% completed, please wait until 100% complete.';
            setOpenRetakeNotificationModal(true);
        } else if (totalCompletedPercentage >= 100) {
            if (isExamineticsEnabled) {
                if (isPreparationInstructionsModalOpenRef.current && !isBypassPreparationModalCheck) {
                    return;
                }
                startUpdateExerciseList.current = false;
            }
            toggleRetakeNotificationModal(false);
            shouldCheckMovementFinished.current = false;
            setIsAssessmentComplete(true);
            await clearAllIntervalsAndStopAudio();

            skippedMovementList.current = await getMovementsOfSelectedStatus(exerciseList.current, CONSTANT.EXERCISE_STATUS.SKIPPED.key) || [];
            skippedMovementList.current = skippedMovementList.current.filter(exercise => !notNeedSkipAndInMovementStatPopupExercisesRef.current.includes(exercise.ExerciseCodeName));

            // if(skippedMovementList.current && skippedMovementList.current.length > 0){
            //     sweetAlertModalObj.current = getSweetAlertModalConfig({
            //         showCancelBtn: true,
            //         showConfirmBtn: true,
            //         alertType: 'warning',
            //         title: '',
            //         confirmBtnText: 'Yes',
            //         cancelBtnText: 'No',
            //         confirmBtnCss: 'btn btn-sm btn-success',
            //         cancelBtnCss: 'btn btn-sm btn-danger',
            //         message: 'You did not complete performing all movements. Do you want to save without those movements?',
            //         closeOnOutsideClick: false,
            //         onConfirm: onConfirmSaveAndClose,
            //         onCancel: () => setIsShowNotificationAlert(false)
            //     });
            //
            //     setIsShowNotificationAlert(true);
            // } else {
            // let msg = 'You have completed the biometric phase of your assessment. Please click save and close.';
            let msg = 'Please allow our system time to analyze your data and generate a report. We will email you when your report is available.';
            if (IsD2CEnabled) {
                msg = <>You have completed the biometric phase of your assessment. Please allow time for our system to analyze your data and generate a report. We will email you when it&lsquo;s ready. Click Save & Close to finish.</>;
            } else if (isExamineticsEnabled) {
                const congratsKeyText = 'stengthExamineticsCongratulations';
                const congratsData = getMessageByKeyText(realTimeDetectionConstrains.current, congratsKeyText);
                msg = congratsData?.message ? (
                    <span dangerouslySetInnerHTML={{ __html: congratsData.message }} />
                ) : (
                    <></>
                );
            } else {
                const congratsKeyText = 'RomCongratulations';
                const congratsData = getMessageByKeyText(realTimeDetectionConstrains.current, congratsKeyText);
                if (congratsData?.message) {
                    msg = <span dangerouslySetInnerHTML={{ __html: congratsData.message }} />;
                }
            }

            sweetAlertModalObj.current = getSweetAlertModalConfig({
                showCancelBtn: false,
                showConfirmBtn: true,
                alertType: 'success',
                title: completionBioMessageTitle || 'Congratulations',
                confirmBtnText: 'Save & Close',
                cancelBtnText: '',
                confirmBtnCss: 'btn btn-sm btn-success',
                cancelBtnCss: '',
                message: msg,
                closeOnOutsideClick: false,
                onConfirm: IsD2CEnabled
                    ?
                    async () => {
                        await onConfirmSaveAndClose();
                        await playAudio('remove');
                        if (isAthleteEnabled) {
                            history.push(`${routes.myAssessments}/false`, {refresh: true});
                        } else {
                            // history.push(routes.dashboard);
                            history.push(routes.dashboard, {refresh: true});
                        }
                        // redirectTo(routes.dashboard);
                    }
                    : saveAndCloseAndLogout
            });

            setIsShowNotificationAlert(true);
            if (IsD2CEnabled) {
                voiceEnable.current && await playGeneralAudio(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.ALL_MOVEMENT_COMPLETED_D2C);
            } else if (isExamineticsEnabled) {
                const congratsData = getMessageByKeyText(realTimeDetectionConstrains.current, 'stengthExamineticsCongratulations');
                if (voiceEnable.current && congratsData && congratsData.audio) {
                    await playAudioWithRetry(congratsData.audio);
                } else if (voiceEnable.current) {
                    await playGeneralAudio(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.ALL_MOVEMENT_COMPLETED);
                }
            } else {
                const congratsData = getMessageByKeyText(realTimeDetectionConstrains.current, 'RomCongratulations');
                if (voiceEnable.current && congratsData && congratsData.audio) {
                    await playAudio(congratsData.audio);
                } else if (voiceEnable.current) {
                    await playGeneralAudio(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.ALL_MOVEMENT_COMPLETED);
                }
            }
            // }
        }
    }
    const handleClosePreparationModal = async () => {
        setShowPreparationInstructionModal(false);
        isPreparationInstructionsModalOpenRef.current = false;

        // FSM: transition from SHOWING_WELCOME_INSTRUCTION → SHOWING_MOVEMENT_INSTRUCTION
        fsm.send(MovementEvent.WELCOME_DISMISSED, {
            selectedExercise: selectedExercise.current,
            videoDuration: videoRecordTime.current,
        });

        // If we're Examinetics, show the specific exercise instructions after closing the prep modal
        if (isExamineticsEnabled && selectedExercise.current && Object.keys(selectedExercise.current).length > 0) {
            setIsVideoTopElementDisabled(true);
            setIsShowExamineticsInstructionModal(true);
        }

        // FSM effects handle instruction audio playback on SHOWING_MOVEMENT_INSTRUCTION

        if (isExamineticsEnabled) {
            let totalPercentage = await calculateTotalCompletedPercentage();
            if (totalPercentage >= 100) {
                await openMovementPercentageModal(true);
            }
        }
    }

    const saveAndCloseAndLogout = async () => {
        await onConfirmSaveAndClose();
        clearAndCloseChatbot && clearAndCloseChatbot();
        deAuthenticate();
        history.push(routes.landing);
        // redirectTo('');
    }

    const setShouldOPenRetakeListModal = (value) => {
        shouldCheckMovementFinished.current = value;
    }

    const controlWithNotificationModal = async () => {
        retakeMovementList.current = await getMovementsOfSelectedStatus(exerciseList.current, CONSTANT.EXERCISE_STATUS.RETAKE.key) || [];

        // Auto-retake logic
        const shouldAutoRetake = isAutoRetakeMode.current && (isExamineticsEnabled || isAutoRetakeFromModal.current);

        if (shouldAutoRetake) {
            let nextRetakeExercise = null;
            if (isExamineticsEnabled) {
                if (retakeMovementList.current && retakeMovementList.current.length > 0) {
                    nextRetakeExercise = retakeMovementList.current[0];
                }
            } else {
                nextRetakeExercise = retakeMovementList.current?.find(ex => !autoRetakenExercisesRef.current.has(ex.ExerciseCodeName));
            }

            if (nextRetakeExercise) {
                if (!isExamineticsEnabled) {
                    autoRetakenExercisesRef.current.add(nextRetakeExercise.ExerciseCodeName);
                }
                await onSelectNextMovement(nextRetakeExercise, true);
                return;
            } else {
                // No more retakes, exit auto-retake mode
                isAutoRetakeMode.current = false;
                isAutoRetakeFromModal.current = false;
                if (!isExamineticsEnabled) {
                    autoRetakenExercisesRef.current.clear();
                }
            }
        }

        if (retakeMovementList.current && retakeMovementList.current.length > 0) {
            setIsShowNotificationAlert(false);
            retakeModal.current = true;
            percentageMessage.current = '';
            setOpenRetakeNotificationModal(true);
        } else {
            await openMovementPercentageModal();
        }
    }

    const onConfirmRetakeAlert = async () => {
        setIsShowNotificationAlert(false);

        // console.log('onSelectNextMovement 6')
        await onSelectNextMovement(retakeExercise.current, true);
    }

    const onCancelRetakeAlert = async () => {
        setIsShowNotificationAlert(false);
        if (selectedExercise.current && selectedExercise.current.Status === CONSTANT.EXERCISE_STATUS.PERFORMING.key) {

            // console.log('onSelectNextMovement 7')
            await onSelectNextMovement(selectedExercise.current, true);
        }
    }

    const onClickRetakeExercise = async (exercise, isFromRetakeModal = false, isFromLeftSidePanel = false) => {
        setIsFullScreenVideo(false);
        shouldCheckMovementFinished.current = false;
        await clearIntervalAndStopAudio(checkFullBodyInterval.current, null, stopPlayingAudio);
        retakeExercise.current = exercise;

        // Start auto-retake sequence
        isAutoRetakeMode.current = true;
        isAutoRetakeFromModal.current = isFromRetakeModal;
        if (isFromRetakeModal && !isExamineticsEnabled) {
            autoRetakenExercisesRef.current.clear();
            autoRetakenExercisesRef.current.add(exercise.ExerciseCodeName);
        }

        openVideoModal.current = false;
        isAnyModalOpenRef.current = false;

        if (!isFromRetakeModal && selectedExercise.current && selectedExercise.current.ExerciseCodeName !== exercise.ExerciseCodeName) {
            let modalHeaderText = retakeExercise.current.Status === CONSTANT.EXERCISE_STATUS.RETAKE.key ? 'Retake' : '';
            let alertMsg =
                (isFromLeftSidePanel && !(retakeExercise.current.Status === CONSTANT.EXERCISE_STATUS.RETAKE.key))
                    ? `Are you sure you want to perform ${retakeExercise.current.ExerciseDisplayName}?`
                    : `Do you want to start ${retakeExercise.current.ExerciseDisplayName} now?`;

            sweetAlertModalObj.current = getSweetAlertModalConfig({
                showCancelBtn: true,
                showConfirmBtn: true,
                alertType: 'warning',
                title: modalHeaderText,
                confirmBtnText: 'Yes',
                cancelBtnText: 'No',
                confirmBtnCss: 'btn btn-sm btn-success',
                cancelBtnCss: 'btn btn-sm btn-danger',
                message: alertMsg,
                closeOnOutsideClick: false,
                onConfirm: onConfirmRetakeAlert,
                onCancel: onCancelRetakeAlert
            });

            setIsShowNotificationAlert(true);
        } else {

            // console.log('onSelectNextMovement 8')
            await onSelectNextMovement(exercise, true);
        }
    }
    
    const toggleRetakeNotificationModal = (value) => {
        setOpenRetakeNotificationModal(value);
    }

    const handleContinueExamineticsAssessment = async () => {
        setOpenRetakeNotificationModal(false);
        forceStopAllAudio();
        selectingExerciseCodeRef.current = null; // Clear duplicate guard — new pass, allow re-selection
        shouldCheckMovementFinished.current = false; // Prevent interval from reopening progress modal
        visitedExercisesRef.current.clear();
        
        // Pre-populate visited list with exercises we don't need to visit again in this loop
        // This ensures visitedExercisesRef.current.size correctly reaches topLevelExercises.length at the end of the pass
        exerciseList.current.forEach(ex => {
            if (
                !ex["IsInMergeExercise"] &&
                ex.Status !== CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name &&
                ex.Status !== CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.key &&
                ex.Status !== CONSTANT.EXERCISE_STATUS.RETAKE.name &&
                ex.Status !== CONSTANT.EXERCISE_STATUS.RETAKE.key
            ) {
                visitedExercisesRef.current.add(ex.ExerciseCodeName);
            }
        });

        // Reset only RETAKE/NOT_PERFORMED.key movements to NOT_PERFORMED.name to show them again cleanly, without repeating already completed ones.
        const updatedList = exerciseList.current.map(ex => {
            if (
                ex.Status === CONSTANT.EXERCISE_STATUS.RETAKE.name ||
                ex.Status === CONSTANT.EXERCISE_STATUS.RETAKE.key ||
                ex.Status === CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.key
            ) {
                return { ...ex, Status: CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name };
            }
            return ex;
        });
        
        exerciseList.current = updatedList;
        setFilteredExerciseList([...updatedList]);
        
        // Small delay to ensure state updates before finding next
        setTimeout(async () => {
            const nextEx = await getNextMovement(exerciseList.current);
            if (nextEx) {
                await onSelectNextMovement(nextEx);
            } else {
                await openMovementPercentageModal();
            }
        }, 100);
    }

    const onStopVideoRecording = async (chunks) => {
        const recordingEndTime = Date.now();
        console.log('recording ends-------------------------------------------', recordingEndTime);
        const recordingStartTime = recordingStartTimeRef.current;
        let recordedDurationSeconds = 0;
        if (recordingStartTime) {
            recordedDurationSeconds = (recordingEndTime - recordingStartTime) / 1000;
            console.log(`[Video Recording Timer] Start: ${new Date(recordingStartTime).toLocaleTimeString()}, Finish: ${new Date(recordingEndTime).toLocaleTimeString()}, Difference: ${recordedDurationSeconds.toFixed(2)} seconds`);
        }

        GLOBAL.IsColorRedForFullBox = true;

        // Only show loader and play ending audio if recording was NOT force-stopped
        if (!wasMultiPersonDetectedRef.current) {
            setIsShowReviewDelayLoader(true);
            const expectedDurationSeconds = Number(videoRecordTime.current) || 0;
            const OUT_OF_FRAME_AUDIO_TOLERANCE_SECONDS = 0.5;
            const isCompletedRecording =
                expectedDurationSeconds <= 0 ||
                recordedDurationSeconds >=
                    expectedDurationSeconds - OUT_OF_FRAME_AUDIO_TOLERANCE_SECONDS;

            if (wasOutOfFrameRecordingStopRef.current && !isCompletedRecording) {
                const messageObj = getMessageByKeyTexts(
                    realTimeDetectionConstrains.current,
                    "BiometricVoiceInteraction",
                    "RecordingOutOfFrame"
                );
                if (messageObj && messageObj.audio && selectedExercise.current.ExerciseCodeName !== 'carrytest') {
                    await playAudio(messageObj.audio, { priorityLevel: 1 });
                }
            } else {
                const messageObj = getMessageByKeyTexts(
                    realTimeDetectionConstrains.current,
                    "general",
                    "endingMovement"
                );
                if (messageObj && messageObj.audio) {
                    await playAudio(messageObj.audio, { priorityLevel: 1 });
                }
                // await playGeneralAudio(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.ENDING_MOVEMENT);
            }
            // Always clear interruption flag after post-recording audio decision.
            wasOutOfFrameRecordingStopRef.current = false;
        }

        // Stop recording immediately
        startRecording.current = false;

        // Notify FSM that recording completed.
        // Send unconditionally — fsm.currentState is stale in this async callback
        // (comes from useReducer React state, not a ref). The FSM reducer ignores
        // invalid transitions as no-ops, so extra events cause no harm.
        fsm.send(MovementEvent.COUNTDOWN_COMPLETE);         // no-op if not in RUNNING_PRE_RECORDING_COUNTDOWN
        fsm.send(MovementEvent.RECORDING_DURATION_COMPLETE); // no-op if not in RECORDING_MOVEMENT_VIDEO

        let blobUrlObj = await getChunksToBlob(chunks);
        recordedBlob.current = blobUrlObj.blob;
        let url = blobUrlObj.url;

        setIsFullScreenVideo(false);

        setPainQuestionList(selectedExercise.current?.PainQuestions || []);

        if (selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.STRENGTH || (selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID && !isExamineticsEnabled)) {
            // check our tracking flag
            if (wasMultiPersonDetectedRef.current) {
                console.log('multi-person was detected, closing review modal for strength exercise');
                openVideoModal.current = false;
                // reset the flag
                wasMultiPersonDetectedRef.current = false;
            } else {
                openVideoModal.current = false;
            }

            await processStrengthMovements(selectedExercise.current);
            setIsShowReviewDelayLoader(false);
        } else {
            if (url) {
                videoUrl.current = url;

                // check our tracking flag
                if (wasMultiPersonDetectedRef.current) {
                    console.log('multi-person was detected, NOT opening review modal');
                    openVideoModal.current = false;
                    // reset the flag
                    wasMultiPersonDetectedRef.current = false;
                    setIsShowReviewDelayLoader(false);
                } else {
                    console.log('single person, opening review modal');
                    openVideoModal.current = true;
                    setIsShowReviewDelayLoader(false);
                }
            } else {
                setIsShowReviewDelayLoader(false);
            }
        }
    };

    const startVideoRecording = () => {
        videoRecordTime.current = getVideoLength(selectedExercise.current);

        // Notify FSM: countdown complete → recording started.
        // Send unconditionally — fsm.currentState may be stale in callback closures.
        // FSM reducer ignores invalid transitions as no-ops.
        fsm.send(MovementEvent.COUNTDOWN_COMPLETE);

        if (imperativeRecordingRef.current) {
            imperativeRecordingRef.current(videoRecordTime.current);
        }

        recordingStartTimeRef.current = Date.now();
        console.log('recording starts-------------------------------------------', recordingStartTimeRef.current);
        startRecording.current = true;

        // Fire-and-forget — don't block recording start on audio loading
        playGeneralAudio(CONSTANT.GENERAL_AUDIOS_KEY_TEXT.STARTING_MOVEMENT);

        if (selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.STRENGTH || selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID) {
            stateRef.current = {
                prevPhase: null,
                currentPhase: null,
                reps: 0
            };
        }
    }

    const onHideCountDown = async () => {
        if (isAnyModalOpenRef.current) {
            console.log('modal is open - aborting recording/countdown completion');
            fsm.send(MovementEvent.COUNTDOWN_CANCELLED);
            return;
        }

        // Final calibration re-check before starting recording (skip for non-measurement exercises)
        if (selectedExercise.current?.IsMeasurementNeeded && !movementRequirementsRef.current.isReadyForCalibration) {
            console.log('calibration no longer valid after countdown - aborting recording');
            setIsFullScreenVideo(false);
            setIsVideoTopElementDisabled(false);
            fsm.send(MovementEvent.COUNTDOWN_CANCELLED);
            return;
        }

        startVideoRecording();
    };

    const onClickMovementAnalyze = async (painQuestionList) => {
        console.log("onClickMovementAnalyze function called and isAnalyzingVideo is.....", isAnalyzingVideo);
        if (!checkAllPainQuestionAnswered(painQuestionList)) {
            return;
        }
        if (isExamineticsEnabled && selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID) {
            setIsAnalyzingVideo(true);
            try {
                await processStrengthMovements(selectedExercise.current);
                openVideoModal.current = false;
            } finally {
                setIsAnalyzingVideo(false);
            }
            return;
        }

        setIsAnalyzingVideo(true);

        try {
            // Callback to handle background failures
            const onAnalysisError = (errorMessage, failedExercise) => {
                console.log("Background analysis failed for", failedExercise?.ExerciseCodeName);
                toast.error(<div>{`Upload failed: ${errorMessage}. Please retake.`}</div>);

                if (exerciseList.current) {
                    // Revert status to NOT_PERFORMED (or RETAKE) so user can try again
                    exerciseList.current = setMovementStatus(exerciseList.current, failedExercise, CONSTANT.EXERCISE_STATUS.NOT_PERFORMED.name);
                    setFilteredExerciseList([...exerciseList.current]);
                }
            };

            let response = await analyzeMovementVideo(painQuestionList, CONSTANT.PROVIDER_EMAIL, testId, bodyRegionList, selectedExercise.current, recordedBlob.current, onAnalysisError);
            recordedBlob.current = null;
            if (response && response.success) {
                lastMovementPerformed.current = getLastPerformedMovement(exerciseList.current, selectedExercise.current);
                let queuedExercises = queuedMovements.current.filter(x => x.exerciseName !== selectedExercise.current.ExerciseCodeName);
                queuedMovements.current = queuedExercises ? queuedExercises : [];
                openVideoModal.current = false;

                // Set to false immediately before any long-running subsequent async tasks
                setIsAnalyzingVideo(false);

                // FSM flow done — allow queue interval to process exercise completion
                isFSMFlowActiveRef.current = false;

                if (!selectedExercise.current?.IsUserCanSkip) {
                    let targetStatus = isExamineticsEnabled ? CONSTANT.EXERCISE_STATUS.COMPLETED.key : CONSTANT.EXERCISE_STATUS.WAITING.key;
                    exerciseList.current = setMovementStatus(exerciseList.current, selectedExercise.current, targetStatus);
                    setFilteredExerciseList(prev => exerciseList.current.slice());
                    isCalibrationProcessing.current = true;
                    await toggleIsUserCanSkipExerciseProcessingAlert(isCalibrationProcessing.current);
                } else {
                    await onClickSelect();
                }
            } else {
                // FSM flow done — allow queue interval to process exercise completion
                isFSMFlowActiveRef.current = false;

                if (response && response.message) {
                    toast.error(
                        <div>{response.message ? response.message : "Unable to analyze the video. Please try again later."}</div>);
                }
            }
        } finally {
            setIsAnalyzingVideo(false);
        }
    }

    const toggleShowMovementBox = (value) => {
        setIsShowSelectMovementBox(value);
    }

    const onClickFullScreen = () => {
        if (GLOBAL.DEVICE_WIDTH >= 1000) {
            setIsFullScreenVideo(prev => !prev);
        }
    }

    const updateWebCamConstraints = useCallback((deviceId) => {
        setWebcamConstraints({...webcamConstraints, deviceId});
    }, []);

    const onClickSwitchCamera = useCallback(() => {
        let cameraFace = webcamConstraints.facingMode === FACING_MODE_USER ? FACING_MODE_ENVIRONMENT : FACING_MODE_USER;
        setWebcamConstraints({...webcamConstraints, facingMode: cameraFace});
    }, []);

    const onChangeDetailedVoiceInstruction = async () => {
        if (voiceEnable.current) {
            // Turning OFF: stop currently playing instruction audio
            await stopPlayingAudio();
        }

        voiceEnable.current = !voiceEnable.current;
        setEnableDetailedVoiceInstruction(!EnableDetailedVoiceInstruction);

        // If audio is being turned on and welcome audio hasn't been played, play it
        const isWelcomeDone = fsm.currentState !== MovementState.SHOWING_WELCOME_INSTRUCTION;
        if (voiceEnable.current && !isWelcomeDone) {
            GLOBAL.AUDIO_PLAY_ENABLED = true;
            try {
                let welcomeTextKey = CONSTANT.GENERAL_AUDIOS_KEY_TEXT.WELCOME_TEXT;
                await playGeneralAudio(welcomeTextKey);
            } catch (error) {
                console.log('Welcome audio failed after toggle:', error);
            }
        }
    }

    const handleExamineticsFullBodyNotVisible = async () => {
        await stopPlayingAudio();
        setShowExamineticsFullBodyModal(true);
        const fullBodyNotVisible = getMessageByKeyTexts(
                    realTimeDetectionConstrains.current,
                    "BiometricVoiceInteraction",
                    "FullBodyNotVisibleMessage"
                );
        if (fullBodyNotVisible) {
            console.log('[AUDIO] playing fullBodyNotVisible audio:', fullBodyNotVisible.audio);
            await playAudio(fullBodyNotVisible.audio, { priorityLevel: 1 });
        }
    };

    const handleExamineticsFullBodyModalConfirm = () => {
        setShowExamineticsFullBodyModal(false);
        notFoundAudioCounter.current = 0;
        patientNotFacingLeft.current = 0;
        patientNotFacingRight.current = 0;
        if (resetVideoPanelStateRef.current) {
            resetVideoPanelStateRef.current();
        }
    };

    // add this new function in MovementCore
    const handleMultiPersonDetected = async () => {
        console.log('multi-person detected, resetting parent state');

        // set our tracking flag
        wasMultiPersonDetectedRef.current = true;

        // reset recording state
        startRecording.current = false;
        setIsFullScreenVideo(false);

        // set multi-person flag
        movementRequirementsRef.current.isMultiPerson = true;
        forceCloseReviewMovementModalRef.current = true;

        // Notify FSM
        fsm.send(MovementEvent.MULTI_PERSON_DETECTED);

        // stop any audio
        await stopPlayingAudio();
    };

    const handleRecordingInterrupted = async (isRecordingActive) => {
        console.log('patient left box, checking interruption type');

        if (isRecordingActive) {
            wasOutOfFrameRecordingStopRef.current = true;
        } else {
            // Don't restart the entire exercise — just go back to WAITING_FOR_USER_VALIDATION
            // The instruction audio already played; replaying it is wrong.
            // Person returns to box → detection continues → flow resumes from where it left off.
            fsm.send(MovementEvent.REQUIREMENTS_LOST);
        }
    };

    function handleDecrement() {
        setTempRepCount(prevCount => {
            // Ensure prevCount is treated as a number (defaults to 0 if null/empty)
            const currentCount = parseInt(prevCount) || 0;
            // Only decrement if the current count is greater than 0
            return currentCount > 0 ? currentCount - 1 : 0;
        });
    }

    function handleIncrement() {
        setTempRepCount(prevCount => {
            // Ensure prevCount is treated as a number. If it's null or an empty string, start at 0.
            const currentCount = parseInt(prevCount) || 0;
            // Increment the count by 1
            return currentCount + 1;
        });
    }
    
    useEffect(() => {
        let interval;

        const isLast = checkIsLastExercise(selectedExercise.current?.ExerciseCodeName);

        const isActive = isExamineticsEnabled && (isAnalyzingVideo || isSubmittingRepCount) && isLast;

        if (isActive) {
            setShowFakeProgress(true);
            setFakeProgressValue(0);
            interval = setInterval(() => {
                setFakeProgressValue(prev => {
                    const increment = Math.random() * 15 + 5;
                    const next = prev + increment;
                    return next > 95 ? 95 : next;
                });
            }, 500);
        } else {
            setFakeProgressValue(prev => prev > 0 ? 100 : 0);
            const timeout = setTimeout(() => {
                setShowFakeProgress(false);
                setFakeProgressValue(0);
            }, 500);
            return () => {
                clearTimeout(timeout);
                if (interval) clearInterval(interval);
            };
        }
        
        return () => clearInterval(interval);
    }, [isAnalyzingVideo, isSubmittingRepCount, isExamineticsEnabled]);

    // FSM context updates when data changes
    useEffect(() => {
        if (isDataLoaded) {
            fsm.sendContext({
                isExamineticsEnabled,
                isMultiPersonDetectionEnable,
                isRealtimeFeedbackROMEnable,
                hasSeenInstructions: !showPreparationInstructionModal,
                selectedExercise: selectedExercise.current,
                videoDuration: videoRecordTime.current,
                isAnyModalOpen: isAnyModalOpen,
            });
        }
    }, [
        isDataLoaded,
        isExamineticsEnabled,
        showPreparationInstructionModal,
        isAnyModalOpen
    ]);

    useEffect(() => {
        if (isAnyModalOpen) {
            // Cancel countdown/pre-recording if a modal opens
            if (fsm.isIn(MovementState.RUNNING_PRE_RECORDING_COUNTDOWN) || 
                fsm.isIn(MovementState.USER_READY_FOR_PRE_RECORDING)) {
                console.log('[FSM] Modal opened during countdown/pre-recording — transitioning back to WAITING_FOR_USER_VALIDATION');
                fsm.send(MovementEvent.REQUIREMENTS_LOST);
            }
        }
    }, [isAnyModalOpen, fsm.currentState]);

    // Warning audio interval — plays "step in box" / "face left/right" audio during active flow
    useEffect(() => {
        const isActive = fsm.currentState !== MovementState.IDLE &&
            fsm.currentState !== MovementState.SHOWING_WELCOME_INSTRUCTION &&
            fsm.currentState !== MovementState.SHOWING_MOVEMENT_INSTRUCTION;

        if (!isActive || !isPageLoaded.current) return;

        // Initial call after 3-second delay (matches old checkFullBodyInBoxThenStartCountDown behavior)
        const initialTimeout = setTimeout(() => {
            checkAndPlayAudio();
        }, 3000);

        // Recurring interval every 10 seconds
        const interval = setInterval(() => {
            checkAndPlayAudio();
        }, 10000);

        return () => {
            clearTimeout(initialTimeout);
            clearInterval(interval);
        };
    }, [fsm.currentState]);

    useEffect(() => {
        setRepCount(stateRef.current.reps);
    }, [stateRef.current.reps]);

    useEffect(() => {
        addEventListenerOnChangeCameraAccess();
        sweetAlertModalObj.current = getSweetAlertModalConfig({});

        fetchData();

        // Always show preparation instructions modal on first load
        if (!isPreparationInstructionsModalOpenRef.current) {
            isPreparationInstructionsModalOpenRef.current = true;
            GLOBAL.AUDIO_PLAY_ENABLED = true;
            setTimeout(() => {
                setShowPreparationInstructionModal(true);
            }, 500);
        }

        return () => {};
    }, []);

    useEffect(() => {
        queueInterval.current = setInterval(() => {
            async function fetchQueuedMovements() {
                queuedMovements.current = await getQueuedMovements(testId);
                addedRemovedExercises.current = await getAddedRemovedExercises(testId);
                setFilteredExerciseList(prevList => {
                    let updatedList = [...prevList];
                    const { addedExercises, removedExercises } = addedRemovedExercises.current;
                    // console.log("it is from filter excercise change.........................", updatedList)
                    // Remove exercises
                    if (removedExercises.length > 0) {
                        updatedList = updatedList.filter(
                            exercise => !removedExercises.includes(exercise.id)
                        );
                    }
                    // Add new exercises
                    if (addedExercises.length > 0) {
                        updatedList = [...updatedList, ...addedExercises];
                    }

                    return updatedList;
                });
                await updateExerciseListAndIsUserCanSkipExercisesStatus();
                if (shouldCheckMovementFinished.current && !isRepCountModalOpenRef.current) {
                    await controlWithNotificationModal();
                }
            }

            if (startUpdateExerciseList.current) {
                fetchQueuedMovements();
            }
        }, 10000);

        return () => {
            clearAllIntervalsAndStopAudio();
        }
    }, []);

    useEffect(() => {
        async function fetchTotalCompletedPercentage() {
            completedPercentage.current = await calculateTotalCompletedPercentage();
        }

        fetchTotalCompletedPercentage();
    });

    useEffect(() => {
        async function viewCompletedModal() {
            await openMovementPercentageModal();
        }

        if (completedPercentage.current >= 100) {
            viewCompletedModal();
        }
    }, [completedPercentage.current]);

    const leftSidePanel = useMemo(() => {
        return <LeftSidePanel
            exerciseList={exerciseList.current}
            filteredExerciseList={filteredExerciseList}
            setFilteredExerciseList={setFilteredExerciseList}
            onClickRetakeExercise={onClickRetakeExercise}
            selectedExercise={selectedExercise.current}
            toggleShowMovementBox={toggleShowMovementBox}
            isShowSelectMovementBox={isShowSelectMovementBox}
            selectedRegions={bodyRegionList}
            childExerciseExerciseCodeNameList={childExerciseExerciseCodeNameList.current}
        />
    }, [filteredExerciseList, isShowSelectMovementBox]);

    const fullBodyNotVisiblePopupDescription = getMessageByKeyTexts(
        realTimeDetectionConstrains.current,
        "BiometricVoiceInteraction",
        "FullBodyNotVisibleMessage"
    );

    return (
        <div className="movement-core">
            <div className={isFullScreenVideo ? "movement-core--hide" : ""}>
                <HeaderPanel
                    EnableDetailedVoiceInstruction={EnableDetailedVoiceInstruction}
                    onChangeDetailedVoiceInstruction={onChangeDetailedVoiceInstruction}
                    onClickSaveAssessment={onClickSaveAndCloseBtn}
                    processingSaveAssessment={processingSaveAssessment}
                    setShowPreparationInstructionModal={setShowPreparationInstructionModal}
                    windowHeaderTitle={windowHeaderTitle}
                />
            </div>
            {isDataLoaded && (
                <>
                    <div
                        className={`${isFullScreenVideo ? "movement-core--hide" : "movement-core--position-relative"} movement-core__progress-bar-container`}>
                        <div className="">
                            <Progressbar progress={completedPercentage.current}/>
                        </div>
                        <div>
                            {/*<NetworkCheck/>*/}
                        </div>
                    </div>
                    <div
                        className={isFullScreenVideo ? "movement-core--hide movement-core--row movement-core--fullscreen movement-core--height-91-4-vh movement-core--justify-between" : "movement-core--row movement-core--height-75-vh movement-core--justify-between"}>
                        <div
                            className='movement-core--position-relative movement-core--w-98-percent movement-core--z-index-101 movement-core--margin-bottom-2-px hide'>
                            <div className='movement-core__select-movement movement-core--w-100-percent'
                                 onClick={() => setIsShowMovementList(prevState => !prevState)}>
                                <p>{selectedExercise.current?.ExerciseDisplayName}</p>
                                <img src={DownArrow} alt='Down Arrow'/>
                            </div>
                            {isShowMovementList &&
                                <div className='movement-core__movent movement-core--w-100-percent'>
                                    {leftSidePanel}
                                </div>
                            }
                        </div>

                        <div className={isFullScreenVideo ? 'movement-core--hide' : 'movement-core__more-than-576px'}>
                            <div
                                className="max-height-inherit movement-core--h-100-percent movement-core--d-flex movement-core--flex-column movement-core--position-relative">
                                {leftSidePanel}
                            </div>
                        </div>

                        <div
                            className={isFullScreenVideo ? "movement-core__video-wrapper max-height-inherit movement-core--h-100-percent movement-core--padding-left-0-important" : "movement-core--position-relative movement-core__width-50-percent  max-height-inherit movement-core--h-100-percent movement-core--d-flex movement-core--flex-column"}>
                            <VideoTopElement
                                onClickPauseBtn={onClickPauseBtn}
                                onClickSkip={handleClickUnableToPerform}
                                // onClickAllDone={handleClickAllDone}
                                selectedExercise={selectedExercise.current}
                                testId={testId}
                                isMovementPaused={isMovementPaused.current}
                                isFullScreenVideo={isFullScreenVideo}
                                isSkipping={isSkipping}
                                isStrengthMovementSaving={isStrengthMovementSaving}
                                isVideoTopElementDisabled={isVideoTopElementDisabled}
                            />
                            <div className="movement-core__video-design">
                                {/*{videoPanel}*/}
                                <VideoPanel
                                    startRecording={startRecording}
                                    stateRef={stateRef}
                                    setRepCount={setRepCount}
                                    onStopVideoRecording={onStopVideoRecording}
                                    totalSeconds={videoRecordTime.current}
                                    webcamConstraints={webcamConstraints}
                                    messageOnVideo={messageOnVideo}
                                    setMessageOnVideo={setMessageOnVideo}
                                    selectedExercise={selectedExercise}
                                    movementRequirementsRef={movementRequirementsRef}
                                    realTimeDetectionConstrains={realTimeDetectionConstrains.current}
                                    forceCloseReviewMovementModalRef={forceCloseReviewMovementModalRef}
                                    onMultiPersonDetected={handleMultiPersonDetected}
                                    onRecordingInterrupted={handleRecordingInterrupted}
                                    openVideoModal={openVideoModal}
                                    isMovementPaused={isMovementPaused}
                                    showPreparationInstructionModal={showPreparationInstructionModal}
                                    isAnyModalOpenRef={isAnyModalOpenRef}
                                    isCalibrationProcessing={isCalibrationProcessing}
                                    isAssessmentComplete={isAssessmentComplete}
                                    isExamineticsEnabled={isExamineticsEnabled}
                                    detectionBridgeRef={detectionBridgeRef}
                                    imperativeRecordingRef={imperativeRecordingRef}
                                    exerciseGeneration={exerciseGeneration}
                                    onExamineticsFullBodyNotVisible={handleExamineticsFullBodyNotVisible}
                                    resetVideoPanelStateRef={resetVideoPanelStateRef}
                                />
                                {fsm.isIn(MovementState.RUNNING_PRE_RECORDING_COUNTDOWN) && (
                                    <div className="movement-core--d-flex-center-center movement-core--h-100-percent">
                                        <CountDown
                                            onComplete={onHideCountDown}
                                        />
                                    </div>
                                )}
                                {!fsm.isIn(MovementState.RUNNING_PRE_RECORDING_COUNTDOWN) && messageOnVideo !== "" && (
                                    <div className="movement-core--d-flex-center-center movement-core--h-100-percent">
                                        <span className="z-index-1 color-red-2 count-down-waring-text">{messageOnVideo}</span>
                                    </div>
                                )}
                                {startRecording.current &&
                                    <div
                                        className="movement-core--d-flex-center-center movement-core__stopwatch-parent">
                                        <StopWatch
                                            isStartStopWatch={startRecording}
                                            totalSeconds={videoRecordTime.current}
                                            selectedExercise={selectedExercise.current}
                                        />
                                    </div>
                                }
                                {!isExamineticsEnabled && 
                                (selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.STRENGTH ||
                                 selectedExercise.current?.ExerciseTypeId === CONSTANT.MOVEMENT_TYPES.HYBRID) &&
                                 isStrengthExerciseAICountDisplayEnable &&
                                 startRecording.current && (
                                  <div className="movement-core--d-flex-center-center movement-core__rep-count">
                                    <RepCount repCount={repCount} />
                                  </div>
                                )}
                                {/*{ ((selectedExercise.current?.ExerciseCodeName === CONSTANT.EXERCISES_NAME.pushUpMale || */}
                                {/*    selectedExercise.current?.ExerciseCodeName === CONSTANT.EXERCISES_NAME.pushUpFemale) && */}
                                {/*    startRecording) && (*/}
                                {/*    <div className="d-flex-center-center">*/}
                                {/*        <AllDoneBtn*/}
                                {/*            selectedExercise={selectedExercise.current}*/}
                                {/*            isStrengthMovementSaving={isStrengthMovementSaving}*/}
                                {/*            onClickAllDone={handleClickAllDone}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*)}*/}
                                <VideoToolbar
                                    isFullScreenVideo={isFullScreenVideo}
                                    onClickFullScreen={onClickFullScreen}
                                    updateWebCamConstraints={updateWebCamConstraints}
                                    onClickSwitchCamera={onClickSwitchCamera}
                                    webcamConstraints={webcamConstraints}
                                    isCorrectOrientation={movementRequirementsRef.current.isCorrectOrientation}
                                    selectedExercise={selectedExercise.current}
                                />
                            </div>
                            {!isFullScreenVideo && (
                                <div className='movement-core__guideline-text'
                                     onClick={() => setShowMovementGuideline(prevState => !prevState)}>
                                    <img className='movement-core__guideline-icon' src={Guideline} alt='Guideline'/>
                                    Guideline
                                </div>
                            )}
                            {showMovementGuideline &&
                                <div className='movement-core__gui'>
                                    <div
                                        className="movement-core__width-25-percent-for-guideline movement-core__below-guideline max-height-inherit movement-core--h-100-percent movement-core--d-flex movement-core--flex-column">
                                        <RightSidePanel
                                            Name={selectedExercise.current?.ExerciseDisplayName}
                                            ExerciseMediaUrl={selectedExercise.current?.ExerciseGuideline?.MediaUrl}
                                            PatientGuidelineContent={selectedExercise.current?.ExerciseGuideline?.InstructionPatient}
                                            closeBtnCallbackFn={() => setShowMovementGuideline(false)}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                        <div
                            className="movement-core__width-25-percent-for-guideline max-height-inherit movement-core--h-100-percent">
                            <RightSidePanel
                                Name={selectedExercise.current?.ExerciseDisplayName}
                                ExerciseMediaUrl={selectedExercise.current?.ExerciseGuideline?.MediaUrl}
                                PatientGuidelineContent={selectedExercise.current?.ExerciseGuideline?.InstructionPatient}
                            />
                        </div>
                    </div>
                    {isExamineticsEnabled ? (
                        <ExamineticsProgressModal
                            isShow={openRetakeNotificationModal}
                            completedCount={exerciseList.current.filter(x => 
                                x.Status === CONSTANT.EXERCISE_STATUS.COMPLETED.key || 
                                x.Status === CONSTANT.EXERCISE_STATUS.RETAKE_HUMAN_EXPERT.key || 
                                x.Status === CONSTANT.EXERCISE_STATUS.SKIPPED.key
                            ).length}
                            totalCount={exerciseList.current.length}
                            onContinue={handleContinueExamineticsAssessment}
                            onExit={onConfirmSaveByClick}
                        />
                    ) : (
                        <RetakeNotificationModal
                            isShow={openRetakeNotificationModal}
                            retakeMovements={retakeMovementList.current}
                            toggleRetakeNotificationModal={setOpenRetakeNotificationModal}
                            onClickRetakeExercise={onClickRetakeExercise}
                            setShouldOPenRetakeListModal={setShouldOPenRetakeListModal}
                            isRetakeModal={retakeModal.current}
                            message={percentageMessage.current}
                            isAudioPlayEnabled={GLOBAL.AUDIO_PLAY_ENABLED}
                            playGeneralAudio={playGeneralAudio}
                            isExamineticsEnabled={isExamineticsEnabled}
                        />
                    )}
                    <StaticVideoModal
                        isShow={openVideoModal}
                        videoUrl={videoUrl.current}
                        painQuestionList={painQuestionList}
                        setPainQuestionList={setPainQuestionList}
                        onClickAnalyze={onClickMovementAnalyze}
                        exercise={selectedExercise.current}
                        onClickRetakeExercise={onClickRetakeExercise}
                        isAnalyzingVideo={isAnalyzingVideo}
                        isAudioPlayEnabled={EnableDetailedVoiceInstruction}
                        playGeneralAudio={playGeneralAudio}
                        realTimeDetectionConstrains={realTimeDetectionConstrains.current}
                        isExamineticsEnabled={isExamineticsEnabled}
                    />
                    {isExamineticsEnabled && isShowReviewDelayLoader && !showFakeProgress && (
                        <div className="movement-core__loading-overlay">
                            <div className="movement-core__loading-overlay-spinner"></div>
                            <div className="movement-core__loading-overlay-message">Please wait</div>
                        </div>
                    )}
                    {showFakeProgress && (
                        <div className="movement-core__loading-overlay" style={{ zIndex: 99999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ width: '80%', maxWidth: '500px', backgroundColor: '#fff', padding: '30px', borderRadius: '12px', textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
                                <h3 style={{ marginBottom: '20px', color: '#333', fontWeight: 'bold' }}>Saving data...</h3>
                                <div style={{ width: '100%', height: '24px', backgroundColor: '#e0e0e0', borderRadius: '12px', overflow: 'hidden', marginBottom: '10px' }}>
                                    <div style={{ width: `${fakeProgressValue}%`, height: '100%', backgroundColor: '#4CAF50', transition: 'width 0.5s ease' }}></div>
                                </div>
                                <p style={{ margin: '0', fontSize: '16px', color: '#666', fontWeight: '500' }}>{Math.round(fakeProgressValue)}%</p>
                            </div>
                        </div>
                    )}
                    <HeightForm
                        isShow={isShowHeightForm}
                        updateBiometricData={updateBiometricData}
                        isUpdatingUserData={isUpdatingUserData}/>

                    <SkipReasonModal
                        isOpen={isShowSkipReasonModal}
                        testId={testId}
                        exercise={exerciseToSkip}
                        onClose={() => {
                            setIsShowSkipReasonModal(false);
                            setExerciseToSkip(null);
                        }}
                        onSubmit={handleSkipReasonSubmit}
                    />

                    {showPreparationInstructionModal && (
                        <PreparationInstructionsModal
                            testId={testId}
                            onClose={handleClosePreparationModal}
                        />
                    )}

                    <ExamineticsInstructionModal
                        isShow={isShowExamineticsInstructionModal}
                        exercise={selectedExercise.current}
                        isVoiceEnabled={voiceEnable.current}
                        onStartTest={startExamineticsExercise}
                        onPerformLater={performLaterExamineticsExercise}
                    />

                    {/*Confirm the displayed count or adjust it manually, then click Confirm to save.*/}

                    {isShowRepCountModal && (
                        <AlertModal
                            show={isShowRepCountModal}
                            type="info"
                            title={`${selectedExercise.current?.ExerciseDisplayName} Reps Confirmation`}
                            confirmBtnText={isSubmittingRepCount ? (
                                <>
                                    <i className="fa fa-spinner fa-spin"/>
                                    &nbsp;&nbsp;Submitting...
                                </>
                            ) : "Confirm"}
                            showConfirm={true}
                            showCancel={true}
                            onConfirm={handleRepCountSubmit}
                            onCancel={() => {
                                setIsShowRepCountModal(false);
                                isRepCountModalOpenRef.current = false;
                                onClickRetakeExercise &&
                                onClickRetakeExercise(selectedExercise.current);
                            }}
                            onClose={() => {
                                setIsShowRepCountModal(false);
                                isRepCountModalOpenRef.current = false;
                                onClickRetakeExercise &&
                                onClickRetakeExercise(selectedExercise.current);
                            }}
                            closeOnClickOutside={false}
                            disabled={isSubmittingRepCount}
                            showLoadingInConform={isSubmittingRepCount}
                            cancelBtnText={"Retake"}
                        >
                        <div className='tele_sweetalert_message'>

                                {isStrengthExerciseAICountEnable && (
                                    <p className="movement-core__rep-count-modal-text">
                                        Record Count <b className="text-black">{tempRepCount || 0}</b>
                                    </p>
                                )}

                                <p className="movement-core__rep-count-modal-text">
                                    {isStrengthExerciseAICountEnable ? "Would you like to adjust the count?" : "Please provide your rep count"}
                                </p>

                                <div className="movement-core__rep-count-modal-controls">
                                    <button
                                        onClick={handleDecrement}
                                        disabled={isSubmittingRepCount}
                                        className="movement-core__rep-count-modal-btn"
                                    >
                                        -
                                    </button>

                                    <input
                                        type="text"
                                        value={tempRepCount}
                                        onChange={handleRepCountChange}
                                        className="movement-core__rep-count-modal-input"
                                    />

                                    <button
                                        onClick={handleIncrement}
                                        disabled={isSubmittingRepCount}
                                        className="movement-core__rep-count-modal-btn"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        </AlertModal>
                    )}
                    {showExamineticsFullBodyModal && (
                        <AlertModal
                            show={showExamineticsFullBodyModal}
                            type="info"
                            showConfirm={true}
                            confirmBtnText="OK"
                            onConfirm={handleExamineticsFullBodyModalConfirm}
                            confirmBtnCssClass="examinetics-ok-btn"
                            closeOnClickOutside={false}
                        >
                            <div>
                                <h2>Full Body Not Visible</h2>
                                <p>
                                    {fullBodyNotVisiblePopupDescription?.message}
                                </p>
                            </div>
                        </AlertModal>
                    )}
                </>
            )}
            {!isDataLoaded && !isShowNotificationAlert && (
                <BiometricLoader/>
            )}
            <NotificationAlert
                isShow={isShowNotificationAlert}
                notificationObj={sweetAlertModalObj.current}
                processingSaveAssessment={processingSaveAssessment || isSkipping}
            />
        </div>
    );
}

export default MovementCore;